import { Box, Button, Container, Grid, TextField } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

let LoaiBoDauSo = [
  '812',
  '816',
  '817',
  '818',
  '832',
  '836',
  '837',
  '838',
  '842',
  '846',
  '847',
  '848',
  '8692',
  '8698',
  '8697',
  '3474',
  '3473',
  '3479',
  '3471',
  '984',
  '981',
  '983',
  '989',
  '971',
  '973',
  '974',
  '979',
  '961',
  '963',
  '964',
  '969',
  '323',
  '324',
  '329',
  '361',
  '363',
  '364',
  '369',
  '371',
  '373',
  '374',
  '379',
  '381',
  '383',
  '384',
  '3881',
  '3883',
  '3884',
  '3484',
  '3921',
  '3923',
  '3924',
  '3929',
  '3963',
  '3964',
  '3969',
  '3971',
  '3973',
  '3974',
  '3979',
  '3484',
  '8692',
  '8696',
  '8697',
  '8698',
  '8612',
  '8616',
  '8617',
  '8618',
  '8621',
  '8623',
  '8624',
  '8629',
  '8632',
  '8636',
  '8637',
  '8638',
  '8642',
  '8646',
  '8647',
  '8648',
  '8671',
  '8673',
  '8674',
  '8679',
  '8681',
  '8683',
  '8684',
  '8689',
  '389',
  '792',
  '796',
  '797',
  '798',
  '736',
  '769',
  '7892',
  '7642',
  '9379',
  '9371',
  '9374',
  '9373',
  '898',
  '896',
  '8152',
  '8156',
  '8157',
  '8158',
  '8352',
  '8356',
  '8357',
  '8358',
  '8452',
  '8456',
  '8457',
  '8458',
  '9854',
  '9851',
  '9853',
  '9859',
  '9751',
  '9753',
  '9754',
  '9759',
  '9651',
  '9653',
  '9654',
  '9659',
  '3253',
  '3254',
  '3259',
  '3653',
  '3654',
  '3659',
  '3751',
  '3753',
  '3754',
  '3759',
  '3851',
  '3853',
  '3854',
  '3859',
  '7952',
  '7956',
  '7957',
  '7958',
  '7952',
  '7956',
  '7957',
  '7958',
  '8958',
  '8956',
  '7952',
  '7956',
  '7957',
  '7958',
  '8897',
  '9121',
  '9173',
  '9169',
  '91961',
  '9184',
  '9148',
  '91181',
  '9181',
  '9124',
  '9142',
  '91361',
  '9163',
  '9179',
  '91971',
  '91161',
  '9161',
  '9129',
  '91921',
  '9183',
  '91381',
  '9174',
  '91471',
  '91171',
  '9171',
  '9123',
  '91321',
  '91461',
  '9164',
  '9189',
  '91981',
  '94121',
  '9421',
  '94371',
  '9473',
  '9469',
  '94961',
  '9484',
  '9448',
  '94181',
  '9481',
  '9424',
  '94421',
  '94361',
  '9463',
  '9479',
  '94971',
  '94161',
  '9461',
  '9429',
  '94921',
  '9483',
  '94381',
  '9474',
  '94471',
  '94171',
  '9471',
  '9423',
  '94321',
  '9464',
  '9489',
  //096
  '9612',
  '9621',
  '9637',
  '9673',
  '9669',
  '9696',
  '96842',
  '9648',
  '9618',
  '96812',
  '96242',
  '9642',
  '9636',
  '9663',
  '96792',
  '9697',
  '9616',
  '9661',
  '96292',
  '9692',
  '96832',
  '9638',
  '96742',
  '9647',
  '9617',
  '96712',
  '96232',
  '9632',
  '9646',
  '9664',
  '96892',
  '9698',

  //097
  '9712',
  '97212',
  '9737',
  '9773',
  '97692',
  '9796',
  '9784',
  '9748',
  '9718',
  '97812',
  '97242',
  '9742',
  '9736',
  '97632',
  '9779',
  '9797',
  '9716',
  '97612',
  '97292',
  '9792',
  '97832',
  '9738',
  '9774',
  '9747',
  '9717',
  '97712',
  '97232',
  '9732',
  '9746',
  '9764',
  '9789',
  '9798',

  //098
  '9812',
  '98212',
  '9837',
  '9873',
  '98692',
  '9896',
  '9884',
  '9848',
  '9818',
  '9881',
  '98242',
  '9842',
  '9836',
  '98632',
  '9879',
  '9897',
  '9816',
  '98612',
  '98292',
  '9892',
  '9883',
  '9838',
  '98742',
  '9847',
  '9817',
  '98712',
  '98232',
  '9832',
  '9846',
  '98642',
  '9889',
  '9898',

  //093
  '9321',
  '93371',
  '9373',
  '9369',
  '93961',
  '9384',
  '93481',
  '9324',
  '9363',
  '9379',
  '9361',
  '9329',
  '9383',
  '9374',
  '9371',
  '9323',
  '9364',
  '9389',
];

function LocSoDep() {
  const [isInputSearch, setIsInputSearch] = useState(false);
  const [dataExcel, setDataExcel] = useState([]);
  const [numberDefault, setNumberDefault] = useState([]);
  const [numberDefault6So, setNumberDefault6So] = useState([]);
  const [numberDefault3So, setNumberDefault3So] = useState([]);
  const [numberDefault8So, setNumberDefault8So] = useState([]);
  const [message, setMessage] = useState('');
  const [dataLocSo, setDataLocSo] = useState([]);
  const [dataLocSoOld, setDataLocSoOld] = useState([]);
  const inputRef = useRef(null);
  const divRef = useRef(null);
  const navigate = useNavigate();
  const hostname = window.location.hostname;

  useEffect(() => {
    // const resultAPISIM = getCookie('token');
    // if (resultAPISIM?.link_domain === hostname) {
    //   console.log(hostname);
    // } else {
    //   navigate('/user/login', { replace: true });
    // }
  }, []);

  function mixPairs() {
    const arr = [
      '13',
      '31',
      '14',
      '41',
      '19',
      '91',
      '26',
      '62',
      '27',
      '72',
      '28',
      '82',
      '34',
      '43',
      '39',
      '93',
      '49',
      '94',
      '67',
      '76',
      '68',
      '86',
      '78',
      '87',
    ];
    let usedPairs = new Set();
    let pairList = [];
    let allPossiblePairs = [];

    // Tạo tất cả các cặp có thể, bao gồm cả chính nó
    for (let i = 0; i < arr.length; i++) {
      for (let j = 0; j < arr.length; j++) {
        let pair = arr[i] + arr[j];
        allPossiblePairs.push(pair);
      }
    }

    // Xáo trộn danh sách cặp để random
    // allPossiblePairs = allPossiblePairs.sort(() => Math.random() - 0.5);

    // Lặp qua danh sách đã xáo trộn và thêm vào kết quả nếu chưa có
    for (let pair of allPossiblePairs) {
      if (!usedPairs.has(pair)) {
        usedPairs.add(pair);
        pairList.push(pair);
      }
    }
    // console.log(pairList);
    setNumberDefault(pairList);
  }

  function mixPairs6() {
    const arr = [
      '13',
      '31',
      '14',
      '41',
      '19',
      '91',
      '26',
      '62',
      '27',
      '72',
      '28',
      '82',
      '34',
      '43',
      '39',
      '93',
      '49',
      '94',
      '67',
      '76',
      '68',
      '86',
      '78',
      '87',
    ];
    let usedPairs = new Set();
    let pairList = [];
    let allPossiblePairs = [];

    // Tạo tất cả các cặp có thể, bao gồm cả chính nó
    for (let i = 0; i < arr.length; i++) {
      for (let j = 0; j < arr.length; j++) {
        for (let k = 0; k < arr.length; k++) {
          let pair = arr[i] + arr[j] + arr[k];
          allPossiblePairs.push(pair);
        }
      }
    }

    // Xáo trộn danh sách cặp để random
    // allPossiblePairs = allPossiblePairs.sort(() => Math.random() - 0.5);

    // Lặp qua danh sách đã xáo trộn và thêm vào kết quả nếu chưa có
    for (let pair of allPossiblePairs) {
      if (!usedPairs.has(pair)) {
        usedPairs.add(pair);
        pairList.push(pair);
      }
    }
    setNumberDefault6So(pairList);
  }
  function mixPairs8() {
    const arr = [
      '13',
      '31',
      '14',
      '41',
      '19',
      '91',
      '26',
      '62',
      '27',
      '72',
      '28',
      '82',
      '34',
      '43',
      '39',
      '93',
      '49',
      '94',
      '67',
      '76',
      '68',
      '86',
      '78',
      '87',
    ];
    let usedPairs = new Set();
    let pairList = [];
    let allPossiblePairs = [];

    // Tạo tất cả các cặp có thể, bao gồm cả chính nó
    for (let i = 0; i < arr.length; i++) {
      for (let j = 0; j < arr.length; j++) {
        for (let h = 0; h < arr.length; h++) {
          for (let k = 0; k < arr.length; k++) {
            let pair = arr[i] + arr[j] + arr[h] + arr[k];
            allPossiblePairs.push(pair);
          }
        }
      }
    }

    // Xáo trộn danh sách cặp để random
    // allPossiblePairs = allPossiblePairs.sort(() => Math.random() - 0.5);

    // Lặp qua danh sách đã xáo trộn và thêm vào kết quả nếu chưa có
    for (let pair of allPossiblePairs) {
      if (!usedPairs.has(pair)) {
        usedPairs.add(pair);
        pairList.push(pair);
      }
    }
    setNumberDefault8So(pairList);
  }

  function mixPairs3() {
    const arr = [
      '13',
      '31',
      '14',
      '41',
      '19',
      '91',
      '26',
      '62',
      '27',
      '72',
      '28',
      '82',
      '34',
      '43',
      '39',
      '93',
      '49',
      '94',
      '67',
      '76',
      '68',
      '86',
      '78',
      '87',
    ];

    const validSet = new Set(arr);
    let result = [];

    // Duyệt mọi số 3 chữ số từ 000 đến 999
    for (let x = 0; x <= 9; x++) {
      for (let y = 0; y <= 9; y++) {
        for (let z = 0; z <= 9; z++) {
          const p1 = `${x}${y}`;
          const p2 = `${y}${z}`;

          // chỉ thêm khi cả 2 cặp đều hợp lệ
          if (validSet.has(p1) && validSet.has(p2)) {
            result.push(`${x}${y}${z}`);
          }
        }
      }
    }

    // Loại trùng
    result = [...new Set(result)];

    // console.log(result);
    setNumberDefault3So(result);
  }

  useEffect(() => {
    mixPairs();
    mixPairs6();
    mixPairs8();
    mixPairs3();
  }, []);

  // Gọi hàm exportToExcel khi bạn muốn tải xuống

  const convertTextToArrayLocSo = (data) => {
    if (data) {
      const dataArrayOld = data.split('\n');
      setDataLocSoOld(dataArrayOld);
      // console.log(phones, dataArrayOld);
      setDataLocSo(data);
    } else {
      setDataLocSo([]);
    }
  };

  function subLoc4So() {
    // Bước 1: Loại bỏ các số chứa "0" trong chuỗi
    const arr = ['72', '27', '28', '82', '26', '62', '66', '77'];
    const arr3so = [
      '133',
      '131',
      '141',
      '191',
      '262',
      '272',
      '282',
      '313',
      '343',
      '393',
      '414',
      '434',
      '494',
      '626',
      '676',
      '686',
      '727',
      '767',
      '787',
      '828',
      '868',
      '878',
      '919',
      '939',
      '949',
      '134',
      '143',
      '314',
      '341',
      '413',
      '431',
      '139',
      '193',
      '319',
      '391',
      '913',
      '931',
      '349',
      '394',
      '439',
      '493',
      '934',
      '943',
      '682',
      '628',
      '862',
      '826',
      '268',
      '286',
      '686',
      '687',
      '678',
      '867',
      '876',
      '768',
      '786',
      '782',
      '728',
      '872',
      '827',
      '278',
      '287',
      '267',
      '276',
      '627',
      '672',
      '762',
      '726',
    ];
    const arr4so = [
      '1344',
      '3144',
      '1334',
      '3114',
      '6822',
      '8622',
      '6877',
      '8677',
      '8662',
      '6882',
      '8667',
      '6887',
      '4933',
      '4993',
      '4991',
      '9433',
      '9443',
      '9441',
      '1393',
      '1399',
    ];

    const arr2so = [
      '13',
      '31',
      '14',
      '41',
      '19',
      '91',
      '26',
      '62',
      '27',
      '72',
      '28',
      '82',
      '34',
      '43',
      '39',
      '93',
      '49',
      '94',
      '67',
      '76',
      '68',
      '86',
      '78',
      '87',
    ];
    const phones = [];
    const dataArray = dataLocSo.split('\n');
    const set4 = new Set(numberDefault);
    const set6 = new Set(numberDefault6So);
    const set8 = new Set(numberDefault8So);

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });
    let filteredData = phones.filter((num) => {
      return num.startsWith('0') && num.slice(1).indexOf('0') === -1;
    });

    // Bước 3: Lọc các số có 4 số cuối nằm trong data2
    filteredData = filteredData.map((num) => {
      const last4 = num.slice(-4);
      const last6 = num.slice(-6);
      const last8 = num.slice(-8);

      const status = set8.has(last8) ? '3' : set6.has(last6) ? '2' : set4.has(last4) ? '1' : '';

      return {
        sim: num,
        status,
      };
    });

    filteredData = filteredData.map(({ sim, status = '' }) => {
      // Bước 1: Loại bỏ các ký tự trùng lặp liên tiếp (VD: 444 → 4)
      const compacted = sim.replace(/(.)\1+/g, '$1');

      // Bước 2: Lấy các chuỗi cuối
      const last4 = compacted.slice(-4);
      const last6 = compacted.slice(-6);
      const last8 = compacted.slice(-8);

      // Bước 3: Kiểm tra trùng
      const newStatus = set8.has(last8) ? '3' : set6.has(last6) ? '2' : set4.has(last4) ? '1' : status;

      return {
        sim,
        status: newStatus,
      };
    });

    filteredData = filteredData.map((num) => {
      let originalNumber = num.sim;

      // Bước 3: Lấy 4 số cuối
      let lastFourDigits = originalNumber.slice(-2);

      // Bước 4: Kiểm tra trùng với numberDefault
      let isMatch = arr.includes(lastFourDigits);
      return {
        status: isMatch ? '' : num.status,
        sim: num.sim,
      };
    });

    // bắt 4 số trùng + 2 số pt
    filteredData = filteredData.map((item) => {
      let status = item.status;
      if (item.sim.length >= 6) {
        const last4 = item.sim.slice(-4); // 4 số cuối
        const prev2 = item.sim.slice(-6, -4); // 2 số trước đó

        if (arr4so.includes(last4) && arr2so.includes(prev2)) {
          status = '4'; // cập nhật status nếu đạt
        }
      }

      if (item.sim.length >= 7) {
        const last3 = item.sim.slice(-3);
        const prev4 = item.sim.slice(-7, -3);

        const zz = prev4.slice(0, 2);
        const yy = prev4.slice(2, 4);

        if (arr2so.includes(zz) && arr2so.includes(yy) && arr3so.includes(last3)) {
          status = '5';
        }
      }

      // ==== Điều kiện mới: trùng 6 số cuối với arr3so (xxxyyy) ====
      if (item.sim.length >= 6) {
        const last6 = item.sim.slice(-6); // lấy 6 số cuối
        const mid3 = last6.slice(0, 3); // xxx
        const end3 = last6.slice(3); // yyy

        if (arr3so.includes(mid3) && arr3so.includes(end3)) {
          status = '6';
        }
      }

      return { ...item, status }; // không đạt thì giữ nguyên
    });

    filteredData = filteredData.filter(
      (item) =>
        item.status === '1' ||
        item.status === '2' ||
        item.status === '3' ||
        item.status === '4' ||
        item.status === '5' ||
        item.status === '6',
    );
    // console.log(filteredData);
    // Bước 5: Loại bỏ các chuỗi trùng lặp

    // lấy dữ liệu hoàn thiện
    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    // console.log(datanew);
    setDataExcel(datanew);
  }

  function subLoc6So() {
    // Bước 1: Loại bỏ các số chứa "0" trong chuỗi
    const arr = ['72', '27', '28', '82', '26', '62', '66', '77'];
    const arr3so = [
      '133',
      '131',
      '141',
      '191',
      '262',
      '272',
      '282',
      '313',
      '343',
      '393',

      '414',
      '434',
      '494',
      '626',
      '676',
      '686',
      '727',
      '767',
      '787',
      '828',
      '868',
      '878',
      '919',
      '939',
      '949',
      '134',
      '143',
      '314',
      '341',
      '413',
      '431',
      '139',
      '193',
      '319',
      '391',
      '913',
      '931',
      '349',
      '394',
      '439',
      '493',
      '934',
      '943',
      '682',
      '628',
      '862',
      '826',
      '268',
      '286',
      '686',
      '687',
      '678',
      '867',
      '876',
      '768',
      '786',
      '782',
      '728',
      '872',
      '827',
      '278',
      '287',
      '267',
      '276',
      '627',
      '672',
      '762',
      '726',
    ];
    const arr4so = [
      '1344',
      '3144',
      '1334',
      '3114',
      '6822',
      '8622',
      '6877',
      '8677',
      '8662',
      '6882',
      '8667',
      '6887',
      '4933',
      '4993',
      '4991',
      '9433',
      '9443',
      '9441',
      '1393',
      '1399',
    ];
    const arr2so = [
      '13',
      '31',
      '14',
      '41',
      '19',
      '91',
      '26',
      '62',
      '27',
      '72',
      '28',
      '82',
      '34',
      '43',
      '39',
      '93',
      '49',
      '94',
      '67',
      '76',
      '68',
      '86',
      '78',
      '87',
    ];
    const targetPrefixes = [
      '812',
      '816',
      '817',
      '818',
      '832',
      '836',
      '837',
      '838',
      '842',
      '846',
      '847',
      '848',
      '984',
      '981',
      '983',
      '989',
      '971',
      '973',
      '974',
      '979',
      '961',
      '963',
      '964',
      '969',
      '323',
      '324',
      '329',
      '361',
      '363',
      '364',
      '369',
      '3484',
      '8692',
      '8698',
      '8697',
      '3474',
      '3473',
      '3479',
      '3471',
      '371',
      '373',
      '374',
      '379',
      '381',
      '383',
      '384',
      '389',
      '792',
      '796',
      '797',
      '798',
      '736',
      '9379',
      '9371',
      '9374',
      '9373',
      '898',
      '896',
      '8152',
      '8156',
      '8157',
      '8158',
      '8352',
      '8356',
      '8357',
      '8358',
      '8452',
      '8456',
      '8457',
      '8458',
      '9854',
      '9851',
      '9853',
      '9859',
      '9751',
      '9753',
      '9754',
      '9759',
      '9651',
      '9653',
      '9654',
      '9659',
      '3253',
      '3254',
      '3259',
      '3653',
      '3654',
      '3659',
      '3751',
      '3753',
      '3754',
      '3759',
      '3851',
      '3853',
      '3854',
      '3859',
      '7952',
      '7956',
      '7957',
      '7958',
      '7952',
      '7956',
      '7957',
      '7958',
      '8958',
      '8956',
      '7952',
      '7956',
      '7957',
      '7958',
      '8897',
      '8696',
    ];
    const phones = [];
    const dataArray = dataLocSo.split('\n');
    const set4 = new Set(numberDefault);
    const set6 = new Set(numberDefault6So);
    const set8 = new Set(numberDefault8So);
    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });
    let filteredData = phones.filter((num) => {
      return num.startsWith('0') && num.slice(1).indexOf('0') === -1;
    });

    filteredData = filteredData.map((num) => {
      const last6 = num.slice(-6);
      const last8 = num.slice(-8);

      const status = set8.has(last8) ? '3' : set6.has(last6) ? '2' : '';

      return {
        sim: num,
        status,
      };
    });

    filteredData = filteredData.map((num) => {
      let originalNumber = num.sim;

      // Bước 3: Lấy 4 số cuối
      let lastFourDigits = originalNumber.slice(-2);

      // Bước 4: Kiểm tra trùng với numberDefault
      let isMatch = arr.includes(lastFourDigits);
      return {
        status: isMatch ? '' : num.status,
        sim: num.sim,
      };
    });

    filteredData = filteredData.map(({ sim, status = '' }) => {
      // Bước 2: Loại bỏ các ký tự trùng lặp liên tiếp (ví dụ: 444 → 4)
      let compacted = '';
      for (let i = 0; i < sim.length; i++) {
        if (i === 0 || sim[i] !== sim[i - 1]) {
          compacted += sim[i];
        }
      }
      // Bước 2: Lấy các chuỗi cuối
      const last6 = compacted.slice(-6);
      const last8 = compacted.slice(-8);

      const last3 = compacted.slice(-3);
      const prev4 = compacted.slice(-5, -3);

      const aa = prev4.slice(0, 2);

      // Bước 3: Kiểm tra trùng
      let newStatus = set8.has(last8)
        ? '3'
        : set6.has(last6)
        ? '2'
        : compacted.length <= 7
        ? arr2so.includes(aa) && arr3so.includes(last3)
          ? '4'
          : status
        : status;

      // hợp bộ 3 số

      if (compacted.length >= 6) {
        let last4 = compacted.slice(-4); // 4 số cuối
        const prev2 = compacted.slice(-6, -4); // 2 số trước đó

        if (arr4so.includes(last4) && arr2so.includes(prev2)) {
          newStatus = '4'; // cập nhật status nếu đạt
        }
      }

      if (compacted.length === 5 || compacted.length === 6) {
        let last4 = compacted.slice(-4); // 4 số cuối
        const prev2 = compacted.slice(-6, -4); // 2 số trước đó

        const zz = last4.slice(0, 2);
        const yy = last4.slice(2, 4);
        if ((arr2so.includes(zz) && arr2so.includes(yy)) || (arr4so.includes(last4) && arr2so.includes(prev2))) {
          newStatus = '4'; // cập nhật status nếu đạt
        }
      }

      if (compacted.length >= 7) {
        const last3 = compacted.slice(-3);
        const prev4 = compacted.slice(-7, -3);

        const zz = prev4.slice(0, 2);
        const yy = prev4.slice(2, 4);

        if (arr2so.includes(zz) && arr2so.includes(yy) && arr3so.includes(last3)) {
          newStatus = '5';
        }
      }

      // ==== Điều kiện mới: trùng 6 số cuối với arr3so (xxxyyy) ====
      if (compacted.length >= 6) {
        const last6 = compacted.slice(-6); // lấy 6 số cuối
        const mid3 = last6.slice(0, 3); // xxx
        const end3 = last6.slice(3); // yyy

        if (arr3so.includes(mid3) && arr3so.includes(end3)) {
          newStatus = '6';
        }
      }

      return {
        sim,
        status: newStatus,
      };
    });

    filteredData = filteredData.map((phone) => {
      // Bước 1: Loại bỏ các ký tự trùng lặp liên tiếp (VD: 444 → 4)
      const compacted = phone.sim.slice(1).replace(/(.)\1+/g, '$1');
      const isStatus = targetPrefixes.some((prefix) => compacted.startsWith(prefix));

      return { ...phone, status: isStatus ? '' : phone.status };
    });

    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );
    // Bước 5: Loại bỏ các chuỗi trùng lặp

    // lấy dữ liệu hoàn thiện
    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);

    // console.log(datanew);
    setDataExcel(datanew);
  }
  function subLoc6SoYes0986() {
    // Bước 1: Loại bỏ các số chứa "0" trong chuỗi
    const arr = ['72', '27', '28', '82', '26', '62', '66', '77'];
    const arrLocDau = ['9', '8'];
    const arrLocDuoi = ['139', '1339', '1399', '86', '866', '68', '688', '13', '133', '31', '311'];
    const arr3so = [
      '133',
      '131',
      '141',
      '191',
      '262',
      '272',
      '282',
      '313',
      '343',
      '393',
      '414',
      '434',
      '494',
      '626',
      '676',
      '686',
      '727',
      '767',
      '787',
      '828',
      '868',
      '878',
      '919',
      '939',
      '949',
      '134',
      '143',
      '314',
      '341',
      '413',
      '431',
      '139',
      '193',
      '319',
      '391',
      '913',
      '931',
      '349',
      '394',
      '439',
      '493',
      '934',
      '943',
      '682',
      '628',
      '862',
      '826',
      '268',
      '286',
      '686',
      '687',
      '678',
      '867',
      '876',
      '768',
      '786',
      '782',
      '728',
      '872',
      '827',
      '278',
      '287',
      '267',
      '276',
      '627',
      '672',
      '762',
      '726',
    ];
    const arr4so = [
      '1344',
      '3144',
      '1334',
      '3114',
      '6822',
      '8622',
      '6877',
      '8677',
      '8662',
      '6882',
      '8667',
      '6887',
      '4933',
      '4993',
      '4991',
      '9433',
      '9443',
      '9441',
      '1393',
      '1399',
    ];
    const arr2so = [
      '13',
      '31',
      '14',
      '41',
      '19',
      '91',
      '26',
      '62',
      '27',
      '72',
      '28',
      '82',
      '34',
      '43',
      '39',
      '93',
      '49',
      '94',
      '67',
      '76',
      '68',
      '86',
      '78',
      '87',
    ];
    const targetPrefixes = LoaiBoDauSo;
    const phones = [];
    const dataArray = dataLocSo.split('\n');
    const set4 = new Set(numberDefault);
    const set3 = new Set(numberDefault3So);
    const set6 = new Set(numberDefault6So);
    const set8 = new Set(numberDefault8So);
    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });
    let filteredData = phones.filter((num) => {
      return num.startsWith('0') && num.slice(1).indexOf('0') === -1;
    });

    // filteredData = filteredData.filter((phone) => {
    //   const normalized = phone.startsWith('0') ? phone.slice(1) : phone;
    //   return (
    //     arrLocDau.some((prefix) => normalized.startsWith(prefix)) || arrLocDuoi.some((tail) => phone.endsWith(tail))
    //   );
    // });

    filteredData = filteredData.map((num) => {
      const last6 = num.slice(-6);
      const last8 = num.slice(-8);

      const status = set8.has(last8) ? '3' : set6.has(last6) ? '2' : '';

      return {
        sim: num,
        status,
      };
    });

    filteredData = filteredData.map((num) => {
      let originalNumber = num.sim;

      // Bước 3: Lấy 4 số cuối
      let lastFourDigits = originalNumber.slice(-2);

      // Bước 4: Kiểm tra trùng với numberDefault
      let isMatch = arr.includes(lastFourDigits);
      return {
        status: isMatch ? '' : num.status,
        sim: num.sim,
      };
    });

    filteredData = filteredData.map(({ sim, status = '' }) => {
      let originalNumber = sim;
      // Bước 1: Loại bỏ tất cả số 5
      let noFive = originalNumber.replace(/5/g, '');

      // Bước 2: Loại bỏ các ký tự trùng lặp liên tiếp (ví dụ: 444 → 4)
      let compacted = '';
      for (let i = 0; i < noFive.length; i++) {
        if (i === 0 || noFive[i] !== noFive[i - 1]) {
          compacted += noFive[i];
        }
      }
      // check đuôi 86

      // Bước 2: Lấy các chuỗi cuối
      const last4 = compacted.slice(-4);
      const last6 = compacted.slice(-6);
      const last8 = compacted.slice(-8);

      const last3 = compacted.slice(-3);
      const prev4 = compacted.slice(-5, -3);

      const prev3Giua = compacted.slice(-5, -2);
      const duoi2soduoi = compacted.slice(-2);
      const dau4sodau = compacted.slice(-9, -5);

      const aa = prev4.slice(0, 2);

      // Bước 3: Kiểm tra trùng
      let newStatus = set8.has(last8)
        ? '3'
        : set6.has(last6)
        ? '2'
        : compacted.length <= 5
        ? set4.has(last4)
          ? '4'
          : status
        : compacted.length <= 7
        ? (arr2so.includes(aa) && arr3so.includes(last3)) ||
          (set4.has(dau4sodau) && set3.has(prev3Giua) && arr2so.includes(duoi2soduoi))
          ? '5'
          : status
        : status;

      // hợp bộ 3 số
      if (compacted.length >= 6) {
        let last4 = compacted.slice(-4); // 4 số cuối
        const prev2 = compacted.slice(-6, -4); // 2 số trước đó

        if (arr4so.includes(last4) && arr2so.includes(prev2)) {
          newStatus = '4'; // cập nhật status nếu đạt
        }
      }

      if (compacted.length === 5 || compacted.length === 6) {
        let last4 = compacted.slice(-4); // 4 số cuối
        const prev2 = compacted.slice(-6, -4); // 2 số trước đó

        const zz = last4.slice(0, 2);
        const yy = last4.slice(2, 4);
        if ((arr2so.includes(zz) && arr2so.includes(yy)) || (arr4so.includes(last4) && arr2so.includes(prev2))) {
          newStatus = '4'; // cập nhật status nếu đạt
        }
      }

      if (compacted.length >= 7) {
        const last3 = compacted.slice(-3);
        const prev4 = compacted.slice(-7, -3);

        const zz = prev4.slice(0, 2);
        const yy = prev4.slice(2, 4);
        if (
          (arr2so.includes(zz) && arr2so.includes(yy) && arr3so.includes(last3)) ||
          (set4.has(dau4sodau) && set3.has(prev3Giua) && arr2so.includes(duoi2soduoi))
        ) {
          newStatus = '5';
        }
      }

      // ==== Điều kiện mới: trùng 6 số cuối với arr3so (xxxyyy) ====
      if (compacted.length >= 6) {
        const last6 = compacted.slice(-6); // lấy 6 số cuối
        const mid3 = last6.slice(0, 3); // xxx
        const end3 = last6.slice(3); // yyy

        if (arr3so.includes(mid3) && arr3so.includes(end3)) {
          newStatus = '6';
        }
      }

      return {
        sim,
        status: newStatus,
      };
    });

    filteredData = filteredData.map((phone) => {
      // Bước 1: Loại bỏ các ký tự trùng lặp liên tiếp (VD: 444 → 4)
      const compacted = phone.sim.slice(1).replace(/(.)\1+/g, '$1');
      const isStatus = targetPrefixes.some((prefix) => compacted.startsWith(prefix));

      return { ...phone, status: isStatus ? '' : phone.status };
    });

    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );
    // Bước 5: Loại bỏ các chuỗi trùng lặp
    filteredData = filteredData.filter((item, index, self) => index === self.findIndex((t) => t.sim === item.sim));

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);

    // console.log(datanew);
    setDataExcel(datanew);
  }
  function subLoc6SoCo5() {
    // Bước 1: Loại bỏ các số chứa "0" trong chuỗi
    const arr = ['72', '27', '28', '82', '26', '62', '66', '77'];
    const arr3so = [
      '133',
      '131',
      '141',
      '191',
      '262',
      '272',
      '282',
      '313',
      '343',
      '393',
      '414',
      '434',
      '494',
      '626',
      '676',
      '686',
      '727',
      '767',
      '787',
      '828',
      '868',
      '878',
      '919',
      '939',
      '949',
      '134',
      '143',
      '314',
      '341',
      '413',
      '431',
      '139',
      '193',
      '319',
      '391',
      '913',
      '931',
      '349',
      '394',
      '439',
      '493',
      '934',
      '943',
      '682',
      '628',
      '862',
      '826',
      '268',
      '286',
      '686',
      '687',
      '678',
      '867',
      '876',
      '768',
      '786',
      '782',
      '728',
      '872',
      '827',
      '278',
      '287',
      '267',
      '276',
      '627',
      '672',
      '762',
      '726',
    ];
    const targetPrefixes = LoaiBoDauSo;
    const arr4so = [
      '1344',
      '3144',
      '1334',
      '3114',
      '6822',
      '8622',
      '6877',
      '8677',
      '8662',
      '6882',
      '8667',
      '6887',
      '4933',
      '4993',
      '4991',
      '9433',
      '9443',
      '9441',
      '1393',
      '1399',
    ];
    const arr2so = [
      '13',
      '31',
      '14',
      '41',
      '19',
      '91',
      '26',
      '62',
      '27',
      '72',
      '28',
      '82',
      '34',
      '43',
      '39',
      '93',
      '49',
      '94',
      '67',
      '76',
      '68',
      '86',
      '78',
      '87',
    ];
    const phones = [];
    const dataArray = dataLocSo.split('\n');
    const set4 = new Set(numberDefault);
    const set6 = new Set(numberDefault6So);
    const set8 = new Set(numberDefault8So);

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });
    let filteredData = phones.filter((num) => {
      return num.startsWith('0') && num.slice(1).indexOf('0') === -1;
    });

    filteredData = filteredData.map((num) => {
      const last6 = num.slice(-6);
      const last8 = num.slice(-8);

      const status = set8.has(last8) ? '3' : set6.has(last6) ? '2' : '';

      return {
        sim: num,
        status,
      };
    });

    filteredData = filteredData.map((num) => {
      let originalNumber = num.sim;

      // Bước 3: Lấy 4 số cuối
      let lastFourDigits = originalNumber.slice(-2);

      // Bước 4: Kiểm tra trùng với numberDefault
      let isMatch = arr.includes(lastFourDigits);
      return {
        status: isMatch ? '' : num.status,
        sim: num.sim,
      };
    });

    filteredData = filteredData.map(({ sim, status = '' }) => {
      let originalNumber = sim;
      // Bước 1: Loại bỏ tất cả số 5
      let noFive = originalNumber.replace(/5/g, '');

      // Bước 2: Loại bỏ các ký tự trùng lặp liên tiếp (ví dụ: 444 → 4)
      let compacted = '';
      for (let i = 0; i < noFive.length; i++) {
        if (i === 0 || noFive[i] !== noFive[i - 1]) {
          compacted += noFive[i];
        }
      }
      // console.log(compacted, compacted.length);

      // Bước 2: Lấy các chuỗi cuối
      const last4 = compacted.slice(-4);
      const last6 = compacted.slice(-6);
      const last8 = compacted.slice(-8);

      const last3 = compacted.slice(-3);
      const prev4 = compacted.slice(-5, -3);

      const aa = prev4.slice(0, 2);

      // Bước 3: Kiểm tra trùng
      let newStatus = set8.has(last8)
        ? '3'
        : set6.has(last6)
        ? '2'
        : compacted.length <= 5
        ? set4.has(last4)
          ? '4'
          : status
        : compacted.length <= 7
        ? arr2so.includes(aa) && arr3so.includes(last3)
          ? '5'
          : status
        : status;

      // hợp bộ 3 số
      if (compacted.length >= 6) {
        let last4 = compacted.slice(-4); // 4 số cuối
        const prev2 = compacted.slice(-6, -4); // 2 số trước đó

        if (arr4so.includes(last4) && arr2so.includes(prev2)) {
          newStatus = '4'; // cập nhật status nếu đạt
        }
      }

      if (compacted.length === 5 || compacted.length === 6) {
        let last4 = compacted.slice(-4); // 4 số cuối
        const prev2 = compacted.slice(-6, -4); // 2 số trước đó

        const zz = last4.slice(0, 2);
        const yy = last4.slice(2, 4);
        if ((arr2so.includes(zz) && arr2so.includes(yy)) || (arr4so.includes(last4) && arr2so.includes(prev2))) {
          newStatus = '4'; // cập nhật status nếu đạt
        }
      }

      if (compacted.length >= 7) {
        const last3 = compacted.slice(-3);
        const prev4 = compacted.slice(-7, -3);

        const zz = prev4.slice(0, 2);
        const yy = prev4.slice(2, 4);
        if (arr2so.includes(zz) && arr2so.includes(yy) && arr3so.includes(last3)) {
          newStatus = '5';
        }
      }

      // ==== Điều kiện mới: trùng 6 số cuối với arr3so (xxxyyy) ====
      if (compacted.length >= 6) {
        const last6 = compacted.slice(-6); // lấy 6 số cuối
        const mid3 = last6.slice(0, 3); // xxx
        const end3 = last6.slice(3); // yyy

        if (arr3so.includes(mid3) && arr3so.includes(end3)) {
          newStatus = '6';
        }
      }

      return {
        sim,
        status: newStatus,
      };
    });

    filteredData = filteredData.map((phone) => {
      // Bước 1: Loại bỏ các ký tự trùng lặp liên tiếp (VD: 444 → 4)
      const compacted = phone.sim.slice(1).replace(/(.)\1+/g, '$1');
      const isStatus = targetPrefixes.some((prefix) => compacted.startsWith(prefix));

      return { ...phone, status: isStatus ? '' : phone.status };
    });

    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    filteredData = filteredData.filter((item) => item.sim.includes('5'));
    // lấy dữ liệu hoàn thiện
    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);

    setDataExcel(datanew);
  }
  function subLoc6886() {
    // Bước 1: Loại bỏ các số chứa "0" trong chuỗi
    const arr = ['72', '27', '28', '82', '26', '62', '66', '77'];
    const arr68 = ['68', '86', '687', '867', '139', '1339', '13339'];
    const targetPrefixes = LoaiBoDauSo;
    const arr3so = [
      '133',
      '131',
      '141',
      '191',
      '262',
      '272',
      '282',
      '313',
      '343',
      '393',
      '414',
      '434',
      '494',
      '626',
      '676',
      '686',
      '727',
      '767',
      '787',
      '828',
      '868',
      '878',
      '919',
      '939',
      '949',
      '134',
      '143',
      '314',
      '341',
      '413',
      '431',
      '139',
      '193',
      '319',
      '391',
      '913',
      '931',
      '349',
      '394',
      '439',
      '493',
      '934',
      '943',
      '682',
      '628',
      '862',
      '826',
      '268',
      '286',
      '686',
      '687',
      '678',
      '867',
      '876',
      '768',
      '786',
      '782',
      '728',
      '872',
      '827',
      '278',
      '287',
      '267',
      '276',
      '627',
      '672',
      '762',
      '726',
    ];
    const arr4so = [
      '1344',
      '3144',
      '1334',
      '3114',
      '6822',
      '8622',
      '6877',
      '8677',
      '8662',
      '6882',
      '8667',
      '6887',
      '4933',
      '4993',
      '4991',
      '9433',
      '9443',
      '9441',
      '1393',
      '1399',
    ];
    const arr2so = [
      '13',
      '31',
      '14',
      '41',
      '19',
      '91',
      '26',
      '62',
      '27',
      '72',
      '28',
      '82',
      '34',
      '43',
      '39',
      '93',
      '49',
      '94',
      '67',
      '76',
      '68',
      '86',
      '78',
      '87',
    ];
    const phones = [];
    const dataArray = dataLocSo.split('\n');
    const set4 = new Set(numberDefault);
    const set3 = new Set(numberDefault3So);
    const set6 = new Set(numberDefault6So);
    const set8 = new Set(numberDefault8So);

    // dataArray.forEach((item) => {
    //   // Tìm cụm có thể là số điện thoại (9–13 ký tự có thể kèm dấu chấm, dấu phẩy)
    //   const matches = item.match(/(?:\d[.,]?){9,13}/g);

    //   if (matches) {
    //     matches.forEach((match) => {
    //       const digitsOnly = match.replace(/[^\d]/g, ''); // loại bỏ tất cả ký tự không phải số

    //       if (digitsOnly.length === 9) {
    //         phones.push('0' + digitsOnly); // thêm 0 nếu thiếu
    //       } else if (digitsOnly.length === 10) {
    //         phones.push(digitsOnly); // giữ nguyên nếu đủ
    //       }
    //       // Bỏ nếu <9 hoặc >10 số
    //     });
    //   }
    // });

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });

    let filteredData = phones.filter((num) => {
      return num.startsWith('0') && num.slice(1).indexOf('0') === -1;
    });

    // console.log(filteredData);

    filteredData = filteredData.map((num) => {
      const last6 = num.slice(-6);
      const last8 = num.slice(-8);
      const status = set8.has(last8) ? '3' : '';

      return {
        sim: num,
        status,
      };
    });

    filteredData = filteredData.map(({ sim, status = '' }) => {
      let originalNumber = sim;
      // Bước 1: Loại bỏ tất cả số 5
      let noFive = originalNumber.replace(/5/g, '');

      // Bước 2: Loại bỏ các ký tự trùng lặp liên tiếp (ví dụ: 444 → 4)
      let compacted = '';
      for (let i = 0; i < noFive.length; i++) {
        if (i === 0 || noFive[i] !== noFive[i - 1]) {
          compacted += noFive[i];
        }
      }
      // check đuôi 86

      // Bước 2: Lấy các chuỗi cuối
      const last4 = compacted.slice(-4);
      const last6 = compacted.slice(-6);
      const last8 = compacted.slice(-8);

      const last3 = compacted.slice(-3);
      const prev4 = compacted.slice(-5, -3);

      const prev3Giua = compacted.slice(-5, -2);
      const duoi2soduoi = compacted.slice(-2);
      const dau4sodau = compacted.slice(-9, -5);

      const aa = prev4.slice(0, 2);

      // Bước 3: Kiểm tra trùng
      let newStatus = set8.has(last8)
        ? '3'
        : set6.has(last6)
        ? '2'
        : compacted.length <= 5
        ? set4.has(last4)
          ? '4'
          : status
        : compacted.length <= 7
        ? (arr2so.includes(aa) && arr3so.includes(last3)) ||
          (set4.has(dau4sodau) && set3.has(prev3Giua) && arr2so.includes(duoi2soduoi))
          ? '5'
          : status
        : status;

      // hợp bộ 3 số
      if (compacted.length >= 6) {
        let last4 = compacted.slice(-4); // 4 số cuối
        const prev2 = compacted.slice(-6, -4); // 2 số trước đó

        if (arr4so.includes(last4) && arr2so.includes(prev2)) {
          newStatus = '4'; // cập nhật status nếu đạt
        }
      }

      if (compacted.length === 5 || compacted.length === 6) {
        let last4 = compacted.slice(-4); // 4 số cuối
        const prev2 = compacted.slice(-6, -4); // 2 số trước đó

        const zz = last4.slice(0, 2);
        const yy = last4.slice(2, 4);
        if ((arr2so.includes(zz) && arr2so.includes(yy)) || (arr4so.includes(last4) && arr2so.includes(prev2))) {
          newStatus = '4'; // cập nhật status nếu đạt
        }
      }

      if (compacted.length >= 7) {
        const last3 = compacted.slice(-3);
        const prev4 = compacted.slice(-7, -3);

        const zz = prev4.slice(0, 2);
        const yy = prev4.slice(2, 4);
        if (
          (arr2so.includes(zz) && arr2so.includes(yy) && arr3so.includes(last3)) ||
          (set4.has(dau4sodau) && set3.has(prev3Giua) && arr2so.includes(duoi2soduoi))
        ) {
          newStatus = '5';
        }
      }

      // ==== Điều kiện mới: trùng 6 số cuối với arr3so (xxxyyy) ====
      if (compacted.length >= 6) {
        const last6 = compacted.slice(-6); // lấy 6 số cuối
        const mid3 = last6.slice(0, 3); // xxx
        const end3 = last6.slice(3); // yyy

        if (arr3so.includes(mid3) && arr3so.includes(end3)) {
          newStatus = '6';
        }
      }

      return {
        sim,
        status: newStatus,
      };
    });

    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    filteredData = filteredData.map(({ sim, status = '' }) => {
      let originalNumber = sim;
      // Bước 1: Loại bỏ tất cả số 5
      let noFive = originalNumber.replace(/5/g, '');

      // Bước 2: Loại bỏ các ký tự trùng lặp liên tiếp (ví dụ: 444 → 4)
      let compacted = '';
      for (let i = 0; i < noFive.length; i++) {
        if (i === 0 || noFive[i] !== noFive[i - 1]) {
          compacted += noFive[i];
        }
      }

      // // check đuôi 86
      let isMatch = arr68.some((ending) => compacted.endsWith(ending));
      // console.log(123, isMatch,noFive)
      let newStatus = isMatch ? '7' : status;
      return {
        sim,
        status: newStatus,
      };
    });

    filteredData = filteredData.map((phone) => {
      // Bước 1: Loại bỏ các ký tự trùng lặp liên tiếp (VD: 444 → 4)
      const compacted = phone.sim.slice(1).replace(/(.)\1+/g, '$1');
      const isStatus = targetPrefixes.some((prefix) => compacted.startsWith(prefix));

      return { ...phone, status: isStatus ? '' : phone.status };
    });

    // console.log(filteredData);

    filteredData = filteredData.filter((item) => item.status === '7');

    // filteredData = filteredData.filter((item) => item.sim.includes('5'));
    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);

    setDataExcel(datanew);
  }

  // Hàm chuẩn hóa số điện thoại, giống logic bạn đã yêu cầu
  function normalizePhone(raw, entry) {
    // Tách theo khoảng trắng
    const parts = entry.trim().split(/\s+/);

    // Kiểm tra có phải dòng có số thứ tự không
    const isIndexLine = /^\d{1,3}$/.test(parts[0]);

    let digits = raw.replace(/[^\d]/g, '');

    // Nếu là dòng có số thứ tự → không ghép phần đầu
    if (isIndexLine && raw.startsWith(parts[0])) {
      return null; // bỏ số thứ tự
    }

    // Nếu số sau khi ghép nằm khoảng 9–10 số thì xử lý
    if (digits.length === 9) return '0' + digits;
    if (digits.length === 10) return digits;

    return null;
  }

  function subLoc6886_095() {
    // Bước 1: Loại bỏ các số chứa "0" trong chuỗi
    const arr = ['72', '27', '28', '82', '26', '62', '66', '77'];
    const targetPrefixes = LoaiBoDauSo;
    const dauso = ['9'];
    const arr68 = ['68', '86', '687', '867', '139', '1339', '13339'];
    const arr3so = [
      '133',
      '131',
      '141',
      '191',
      '262',
      '272',
      '282',
      '313',
      '343',
      '393',
      '414',
      '434',
      '494',
      '626',
      '676',
      '686',
      '727',
      '767',
      '787',
      '828',
      '868',
      '878',
      '919',
      '939',
      '949',
      '134',
      '143',
      '314',
      '341',
      '413',
      '431',
      '139',
      '193',
      '319',
      '391',
      '913',
      '931',
      '349',
      '394',
      '439',
      '493',
      '934',
      '943',
      '682',
      '628',
      '862',
      '826',
      '268',
      '286',
      '686',
      '687',
      '678',
      '867',
      '876',
      '768',
      '786',
      '782',
      '728',
      '872',
      '827',
      '278',
      '287',
      '267',
      '276',
      '627',
      '672',
      '762',
      '726',
    ];

    const arr4so = [
      '1344',
      '3144',
      '1334',
      '3114',
      '6822',
      '8622',
      '6877',
      '8677',
      '8662',
      '6882',
      '8667',
      '6887',
      '4933',
      '4993',
      '4991',
      '9433',
      '9443',
      '9441',
      '1393',
      '1399',
    ];
    const arr2so = [
      '13',
      '31',
      '14',
      '41',
      '19',
      '91',
      '26',
      '62',
      '27',
      '72',
      '28',
      '82',
      '34',
      '43',
      '39',
      '93',
      '49',
      '94',
      '67',
      '76',
      '68',
      '86',
      '78',
      '87',
    ];
    const phones = [];
    const dataArray = dataLocSo.split('\n');
    const set4 = new Set(numberDefault);
    const set3 = new Set(numberDefault3So);
    const set6 = new Set(numberDefault6So);
    const set8 = new Set(numberDefault8So);

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });
    let filteredData = phones.filter((num) => {
      return num.startsWith('0') && num.slice(1).indexOf('0') === -1;
    });

    filteredData = filteredData.filter((phone) => {
      const normalized = phone.startsWith('0') ? phone.slice(1) : phone;
      return dauso.some((prefix) => normalized.startsWith(prefix));
    });

    filteredData = filteredData.map((num) => {
      const last6 = num.slice(-6);
      const last8 = num.slice(-8);
      const status = set8.has(last8) ? '3' : '';

      return {
        sim: num,
        status,
      };
    });

    filteredData = filteredData.map(({ sim, status = '' }) => {
      let originalNumber = sim;
      // Bước 1: Loại bỏ tất cả số 5
      let noFive = originalNumber.replace(/5/g, '');

      // Bước 2: Loại bỏ các ký tự trùng lặp liên tiếp (ví dụ: 444 → 4)
      let compacted = '';
      for (let i = 0; i < noFive.length; i++) {
        if (i === 0 || noFive[i] !== noFive[i - 1]) {
          compacted += noFive[i];
        }
      }
      // check đuôi 86

      // Bước 2: Lấy các chuỗi cuối
      const last4 = compacted.slice(-4);
      const last6 = compacted.slice(-6);
      const last8 = compacted.slice(-8);

      const last3 = compacted.slice(-3);
      const prev4 = compacted.slice(-5, -3);
      const prev3Giua = compacted.slice(-5, -2);
      const duoi2soduoi = compacted.slice(-2);
      const dau4sodau = compacted.slice(-9, -5);

      const aa = prev4.slice(0, 2);

      // Bước 3: Kiểm tra trùng
      let newStatus = set8.has(last8)
        ? '3'
        : set6.has(last6)
        ? '2'
        : compacted.length <= 5
        ? set4.has(last4)
          ? '4'
          : status
        : compacted.length <= 7
        ? (arr2so.includes(aa) && arr3so.includes(last3)) ||
          (set4.has(dau4sodau) && set3.has(prev3Giua) && arr2so.includes(duoi2soduoi))
          ? '5'
          : status
        : status;

      // hợp bộ 3 số
      if (compacted.length >= 6) {
        let last4 = compacted.slice(-4); // 4 số cuối
        const prev2 = compacted.slice(-6, -4); // 2 số trước đó

        if (arr4so.includes(last4) && arr2so.includes(prev2)) {
          newStatus = '4'; // cập nhật status nếu đạt
        }
      }

      if (compacted.length === 5 || compacted.length === 6) {
        let last4 = compacted.slice(-4); // 4 số cuối
        const prev2 = compacted.slice(-6, -4); // 2 số trước đó

        const zz = last4.slice(0, 2);
        const yy = last4.slice(2, 4);
        if ((arr2so.includes(zz) && arr2so.includes(yy)) || (arr4so.includes(last4) && arr2so.includes(prev2))) {
          newStatus = '4'; // cập nhật status nếu đạt
        }
      }

      if (compacted.length >= 7) {
        const last3 = compacted.slice(-3);
        const prev4 = compacted.slice(-7, -3);

        const zz = prev4.slice(0, 2);
        const yy = prev4.slice(2, 4);
        if (
          (arr2so.includes(zz) && arr2so.includes(yy) && arr3so.includes(last3)) ||
          (set4.has(dau4sodau) && set3.has(prev3Giua) && arr2so.includes(duoi2soduoi))
        ) {
          newStatus = '5';
        }
      }

      // ==== Điều kiện mới: trùng 6 số cuối với arr3so (xxxyyy) ====
      if (compacted.length >= 6) {
        const last6 = compacted.slice(-6); // lấy 6 số cuối
        const mid3 = last6.slice(0, 3); // xxx
        const end3 = last6.slice(3); // yyy

        if (arr3so.includes(mid3) && arr3so.includes(end3)) {
          newStatus = '6';
        }
      }

      return {
        sim,
        status: newStatus,
      };
    });

    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    filteredData = filteredData.map(({ sim, status = '' }) => {
      let originalNumber = sim;
      // Bước 1: Loại bỏ tất cả số 5
      let noFive = originalNumber.replace(/5/g, '');

      // Bước 2: Loại bỏ các ký tự trùng lặp liên tiếp (ví dụ: 444 → 4)
      let compacted = '';
      for (let i = 0; i < noFive.length; i++) {
        if (i === 0 || noFive[i] !== noFive[i - 1]) {
          compacted += noFive[i];
        }
      }

      // // check đuôi 86
      let isMatch = arr68.some((ending) => compacted.endsWith(ending));
      // console.log(123, isMatch,noFive)
      let newStatus = isMatch ? '7' : status;
      return {
        sim,
        status: newStatus,
      };
    });

    filteredData = filteredData.map((phone) => {
      // Bước 1: Loại bỏ các ký tự trùng lặp liên tiếp (VD: 444 → 4)
      const compacted = phone.sim.slice(1).replace(/(.)\1+/g, '$1');
      const isStatus = targetPrefixes.some((prefix) => compacted.startsWith(prefix));

      return { ...phone, status: isStatus ? '' : phone.status };
    });

    filteredData = filteredData.filter((item) => item.status === '7');

    // filteredData = filteredData.filter((item) => item.sim.includes('5'));
    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);

    setDataExcel(datanew);
  }
  function subLoc6886_09() {
    // Bước 1: Loại bỏ các số chứa "0" trong chuỗi
    const arr = ['72', '27', '28', '82', '26', '62', '66', '77'];
    const targetPrefixes = LoaiBoDauSo;
    const dauso = ['9'];
    const arr68 = ['68', '86'];
    const arrno68 = ['85', '65', '56', '58', '566', '588', '855', '655', '865', '685'];
    const arr3so = [
      '133',
      '131',
      '141',
      '191',
      '262',
      '272',
      '282',
      '313',
      '343',
      '393',
      '414',
      '434',
      '494',
      '626',
      '676',
      '686',
      '727',
      '767',
      '787',
      '828',
      '868',
      '878',
      '919',
      '939',
      '949',
      '134',
      '143',
      '314',
      '341',
      '413',
      '431',
      '139',
      '193',
      '319',
      '391',
      '913',
      '931',
      '349',
      '394',
      '439',
      '493',
      '934',
      '943',
      '682',
      '628',
      '862',
      '826',
      '268',
      '286',
      '686',
      '687',
      '678',
      '867',
      '876',
      '768',
      '786',
      '782',
      '728',
      '872',
      '827',
      '278',
      '287',
      '267',
      '276',
      '627',
      '672',
      '762',
      '726',
    ];

    const arr4so = [
      '1344',
      '3144',
      '1334',
      '3114',
      '6822',
      '8622',
      '6877',
      '8677',
      '8662',
      '6882',
      '8667',
      '6887',
      '4933',
      '4993',
      '4991',
      '9433',
      '9443',
      '9441',
      '1393',
      '1399',
    ];
    const arr2so = [
      '13',
      '31',
      '14',
      '41',
      '19',
      '91',
      '26',
      '62',
      '27',
      '72',
      '28',
      '82',
      '34',
      '43',
      '39',
      '93',
      '49',
      '94',
      '67',
      '76',
      '68',
      '86',
      '78',
      '87',
    ];
    const phones = [];
    const dataArray = dataLocSo.split('\n');
    const set4 = new Set(numberDefault);
    const set3 = new Set(numberDefault3So);
    const set6 = new Set(numberDefault6So);
    const set8 = new Set(numberDefault8So);

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });
    let filteredData = phones.filter((num) => {
      return num.startsWith('0') && num.slice(1).indexOf('0') === -1;
    });

    filteredData = filteredData.filter((phone) => {
      const normalized = phone.startsWith('0') ? phone.slice(1) : phone;

      // Điều kiện 1: đầu số phải thuộc danh sách dauso
      const isValidPrefix = dauso.some((prefix) => normalized.startsWith(prefix));

      // Điều kiện 2: đuôi KHÔNG được nằm trong arr68
      const isValidTail = !arrno68.some((tail) => phone.endsWith(tail));

      return isValidPrefix && isValidTail;
    });

    filteredData = filteredData.map((num) => {
      const last6 = num.slice(-6);
      const last8 = num.slice(-8);
      const status = set8.has(last8) ? '3' : '';

      return {
        sim: num,
        status,
      };
    });

    filteredData = filteredData.map(({ sim, status = '' }) => {
      let originalNumber = sim;
      // Bước 1: Loại bỏ tất cả số 5
      let noFive = originalNumber.replace(/5/g, '');

      // Bước 2: Loại bỏ các ký tự trùng lặp liên tiếp (ví dụ: 444 → 4)
      let compacted = '';
      for (let i = 0; i < noFive.length; i++) {
        if (i === 0 || noFive[i] !== noFive[i - 1]) {
          compacted += noFive[i];
        }
      }
      // check đuôi 86

      // Bước 2: Lấy các chuỗi cuối
      const last4 = compacted.slice(-4);
      const last6 = compacted.slice(-6);
      const last8 = compacted.slice(-8);

      const last3 = compacted.slice(-3);
      const prev4 = compacted.slice(-5, -3);
      const prev3Giua = compacted.slice(-5, -2);
      const duoi2soduoi = compacted.slice(-2);
      const dau4sodau = compacted.slice(-9, -5);

      const aa = prev4.slice(0, 2);
      // console.log(123, dau4sodau, prev3Giua, duoi2soduoi, arr3so, set6);
      // Bước 3: Kiểm tra trùng
      let newStatus = set8.has(last8)
        ? '3'
        : set6.has(last6)
        ? '2'
        : compacted.length <= 5
        ? set4.has(last4)
          ? '4'
          : status
        : compacted.length <= 7
        ? (arr2so.includes(aa) && arr3so.includes(last3)) ||
          (set4.has(dau4sodau) && set3.has(prev3Giua) && arr2so.includes(duoi2soduoi))
          ? '5'
          : status
        : status;
      // hợp bộ 3 số
      if (compacted.length >= 6) {
        let last4 = compacted.slice(-4); // 4 số cuối
        const prev2 = compacted.slice(-6, -4); // 2 số trước đó

        if (arr4so.includes(last4) && arr2so.includes(prev2)) {
          newStatus = '4'; // cập nhật status nếu đạt
        }
      }

      if (compacted.length === 5 || compacted.length === 6) {
        let last4 = compacted.slice(-4); // 4 số cuối
        const prev2 = compacted.slice(-6, -4); // 2 số trước đó

        const zz = last4.slice(0, 2);
        const yy = last4.slice(2, 4);
        if ((arr2so.includes(zz) && arr2so.includes(yy)) || (arr4so.includes(last4) && arr2so.includes(prev2))) {
          newStatus = '4'; // cập nhật status nếu đạt
        }
      }

      if (compacted.length >= 7) {
        const last3 = compacted.slice(-3);
        const prev4 = compacted.slice(-7, -3);

        const zz = prev4.slice(0, 2);
        const yy = prev4.slice(2, 4);
        if (
          (arr2so.includes(zz) && arr2so.includes(yy) && arr3so.includes(last3)) ||
          (set4.has(dau4sodau) && set3.has(prev3Giua) && arr2so.includes(duoi2soduoi))
        ) {
          newStatus = '5';
        }
      }

      // ==== Điều kiện mới: trùng 6 số cuối với arr3so (xxxyyy) ====
      if (compacted.length >= 6) {
        const last6 = compacted.slice(-6); // lấy 6 số cuối
        const mid3 = last6.slice(0, 3); // xxx
        const end3 = last6.slice(3); // yyy

        if (arr3so.includes(mid3) && arr3so.includes(end3)) {
          newStatus = '6';
        }
      }

      return {
        sim,
        status: newStatus,
      };
    });

    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    filteredData = filteredData.map(({ sim, status = '' }) => {
      let originalNumber = sim;
      // Bước 1: Loại bỏ tất cả số 5
      let noFive = originalNumber.replace(/5/g, '');

      // Bước 2: Loại bỏ các ký tự trùng lặp liên tiếp (ví dụ: 444 → 4)
      let compacted = '';
      for (let i = 0; i < noFive.length; i++) {
        if (i === 0 || noFive[i] !== noFive[i - 1]) {
          compacted += noFive[i];
        }
      }

      // // check đuôi 86
      let isMatch = arr68.some((ending) => compacted.endsWith(ending));
      // console.log(123, isMatch,noFive)
      let newStatus = isMatch ? '7' : status;
      return {
        sim,
        status: newStatus,
      };
    });

    filteredData = filteredData.map((phone) => {
      // Bước 1: Loại bỏ các ký tự trùng lặp liên tiếp (VD: 444 → 4)
      const compacted = phone.sim.slice(1).replace(/(.)\1+/g, '$1');
      const isStatus = targetPrefixes.some((prefix) => compacted.startsWith(prefix));

      return { ...phone, status: isStatus ? '' : phone.status };
    });

    filteredData = filteredData.filter((item) => item.status === '7');

    // filteredData = filteredData.filter((item) => item.sim.includes('5'));
    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);

    setDataExcel(datanew);
  }

  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      // setValue(text);
      convertTextToArrayLocSo(text);

      // Tự focus vào input sau khi dán
      inputRef.current?.focus();
    } catch (err) {
      alert('Không thể truy cập clipboard. Bạn cần cho phép truy cập.');
      console.error(err);
    }
  };

  const handleCopy = async () => {
    try {
      const text = divRef.current.innerText;
      await navigator.clipboard.writeText(text);
      setMessage('Đã sao chép nội dung!');
    } catch (err) {
      setMessage('Không thể sao chép!');
      console.error(err);
    }
  };

  const PhoneFilterDauSo = () => {
    // const targetPrefixes = ['333', '345', '777', '888', '707', '999', '789'];
    const targetPrefixes = [
      '333',
      '345',
      '345345',
      '32345',
      '356789',
      '396789',
      '395678',
      '393456',
      '392345',
      '394567',
      '333999',
      '333888',
      '335577',
      '334455',
      '8678910',
      '345567',
      '333444',
      '339339',
      '399399',
      '379379',
      '3797978',
      '3393938',
      '334567',
      '383979',
      '98989',
      '399799',
      '399499',
      '778899',
      '797979',
      '787878',
      '767676',
      '779779',
      '789789',
      '70707',
      '77777',
      '799799',
      '776776',
      '772772',
      '778778',
      '788788',
      '768768',
      '786786',
      '0909',
      '78910',
      '796789',
      '795678',
      '793456',
      '792345',
      '794567',
    ];
    const phones = [];
    const dataArray = dataLocSo.split('\n');

    // dataArray.forEach((item) => {
    //   // Tìm cụm có thể là số điện thoại (9–13 ký tự có thể kèm dấu chấm, dấu phẩy)
    //   const matches = item.match(/(?:\d[.,]?){9,13}/g);

    //   if (matches) {
    //     matches.forEach((match) => {
    //       const digitsOnly = match.replace(/[^\d]/g, ''); // loại bỏ tất cả ký tự không phải số

    //       if (digitsOnly.length === 9) {
    //         phones.push('0' + digitsOnly); // thêm 0 nếu thiếu
    //       } else if (digitsOnly.length === 10) {
    //         phones.push(digitsOnly); // giữ nguyên nếu đủ
    //       }
    //       // Bỏ nếu <9 hoặc >10 số
    //     });
    //   }
    // });

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });

    let filteredData = phones.filter((phone) => {
      const normalized = phone.startsWith('0') ? phone.slice(1) : phone;
      return targetPrefixes.some((prefix) => normalized.startsWith(prefix));
    });

    filteredData = filteredData.map((item) => {
      return { sim: item, status: '2' };
    });

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    setDataExcel(datanew);
  };
  const PhoneFilterTien2Phim = () => {
    const phones = [];
    const dataArray = dataLocSo?.split('\n');
    const formatList = [
      '68xx86xx',
      '68xx79xx',
      '6969xx69',
      '7979xx79',
      '6879xx79',
      '6979xx79',
      '6868xx68',
      '6968xx68',
      '8686xx86',
      'aaxaxx',
      'axbaxb',
      'abxabx',
      'xabxab',
      'axabbb',
      'aaaax',
      'aabbccx',
      'ababxxab',
      'axaxxax',
      'abcxabcx',
      'abcaac',
      'abcabb',
      'abcdbc',
      'abcabd',
      'axaxaxc',
      'axaxax',
      'xaxaxa',
      'abccba',
      'abcbdb',
      'aabbccdd',
      'abbaba',
      'ababba',
      'xaaabbbx',
      'abcxxabc',
      'xacbxacb', // dạng lặp gãy giữa
      'aaxxaa',
      'abxxab',
      'axaaxa',
      'axabxb',
      'abbacc',
      'xaaxaa',
      '68',
      '86',
      '79',
      'x68x79',
      'x86x68',
      'x39x79',
      'x79x68',
      'x79x86',
      'x39x86',
      'x86x39',
      'x68x39',
      'abbb',
      'axbaxb',
      'abxabx',
      'xabxab',
      'axabbb',
      'aaaax',
      'aabbccx',
      'axaxxax',
      'abcxabcx',
      'abcaac',
      'abcabb',
      'abcdbc',
      'abcabd',
      'axaxaxc',
      'axaxax',
      'xaxaxa',
      'abccba',
      'abcbdb',
      'aabbccdd',
      'abbaba',
      'ababba',
      'xaaabbbx',
      'abcxxabc',
      'xacbxacb',
      'aaxxaa',
      'abxxab',
      'axaaxa',
      'axabxb',
      'abbacc',
      'xaxaa',
      'aaaaaa',
      'aaaaa',
      'aaaa',
      'aaabbb',
      'abbacc',
      'xaaa',
      'xbbaaa',
      'bbxaaa',
      'bxbaaa',
      'abcaaa',
      'abcabd',
      'xaaabbbx',
      'aaabbbxx',
      'ababab',
      'abcdabcd',
      'baabaa',
      'aabaab',
      'abaaba',
      'abcabc',
      'abccba',
      'abbacbbc',
      'abba',
      'aabb',
      'aabbcc',
      'aabbaa',
      'aabcaa',
      'abccab',
      'abcdab',
      'aabaac',
      'abbcbb',
      'abaaca',
      'aabcab',
      'abbacb',
      'abcdde',
      'ababcab',
      'abacad',
      'abc bdb',
      'aaaabcd',
      'aaaabca',
      'aaaabac',
      'aaaabbc',
      'aaaab',
      'aaabcd',
      'aaabcc',
      'aaabac',
      'aaabca',
      'aaabbc',
      'xacbxacb',
      'abac',
      'abab',
      'abbaba',
      'aabacb',
      'abcb',
      'abbcdd',
      'aabccd',
      'aabcdd',
      'abbccd',
      'abaccd',
      'abacdd',
      'aabcdd',
      'abcbdb',
      'aabbccdd',
      'aabbaacc',
      'aabbbbaa',
      'aabbbbcc',
      'abcdbc',
      'abcadc',
      'aabbcde',
      'aabbcad',
      'aabbcbd',
      'aabbcd',
      'aabbca',
      'aabbcb',
      'ababac',
      'ababcd',
      'ababbc',
      'ababaa',
      'ababbb',
      'ababba',
      'ababcde',
      'ababacd',
      'ababaac',
      'abababc',
      'ababbdc',
      'ababbc',
      'ababc',
      'ababa',
      'ababb',
      'abcdee',
      'abcdda',
      'abcddb',
      'abcddc',
      'abbacd',
      'abbbcd',
      'aabcde',
      'abcdbc',
      'abcacb',
      'abcbac',
      'abcbca',
      'aaaaab',
      'aaaaabc',
      'aaaabc',
      'aaaaba',
      'aaaab',
      'aaaabb',
      'aaaaaab',
      'aaaaaabc',
      'aaaaabcd',
      'abacac',
      'ababxab',
    ];

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });

    let filteredData = phones.map((item) => {
      return { sim: item, status: '' };
    });

    // filteredData = filteredData.map((item) => {
    //   if (dataTrung.some((subStr) => item.sim.includes(subStr))) {
    //     return { ...item, status: '6' }; // nếu trùng, set status = 6
    //   }
    //   return item; // không trùng, giữ nguyên
    // });

    // filteredData = filteredData.map((phone) => {
    //   const normalized = phone.sim.startsWith('0') ? phone.sim.slice(1) : phone.sim;

    //   const matchPrefix = targetPrefixes.some((prefix) => normalized.startsWith(prefix));
    //   const matchSuffix = targetSuffixes.some((suffix) => normalized.endsWith(suffix));

    //   let status = matchPrefix || matchSuffix ? '2' : phone.status;

    //   // Check phong thuỷ (nếu chưa phải 2)
    //   // if (status !== '2') {
    //   //   let count = 0;
    //   //   for (const pair of phongthuy) {
    //   //     const regex = new RegExp(pair, 'g');
    //   //     const matches = normalized.match(regex);
    //   //     if (matches) count += matches.length;
    //   //   }
    //   //   if (count >= 4) {
    //   //     status = '4';
    //   //   }
    //   // }

    //   return {
    //     ...phone,
    //     status,
    //     fm: logicFormatSim(phone.sim),
    //   };
    // });
    // console.log(filteredData);

    function matchPattern(num, pattern, opts = { distinctPlaceholders: true }) {
      if (num.length !== pattern.length) return false;
      const map = Object.create(null);
      const used = new Set();

      for (let i = 0; i < pattern.length; i++) {
        const p = pattern[i];
        const n = num[i];

        if (p === 'x') {
          // wildcard 1 chữ số
          continue;
        }
        if (/\d/.test(p)) {
          // literal digit phải khớp
          if (p !== n) return false;
          continue;
        }
        // placeholder letter
        if (!(p in map)) {
          if (opts.distinctPlaceholders && used.has(n)) return false;
          map[p] = n;
          used.add(n);
        } else if (map[p] !== n) {
          return false;
        }
      }
      return true;
    }

    // Giữ nguyên cấu trúc cũ: kiểm tra ĐUÔI của sim theo độ dài pattern
    filteredData = filteredData.map((s) => {
      const sim = (s.sim || '').replace(/\D/g, '');
      const matched = formatList.some((p) => matchPattern(sim.slice(-p.length), p));
      return { sim, status: matched ? '3' : s.status, fm: '' };
    });
    // console.log(filteredData);

    // console.log(123, filteredData);
    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    setDataExcel(datanew);
  };
  const PhoneFilterTien3Phim = () => {
    const phones = [];
    const dataArray = dataLocSo?.split('\n');

    // B1: lấy tất cả số từ dataLocSo
    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });

    // B2: lọc sim hợp lệ
    let filteredData = phones.map((item) => {
      const normalized = item.startsWith('0') ? item.slice(1) : item; // bỏ số 0 đầu để tính
      const digitsNonZero = normalized.replace(/[^1-9]/g, ''); // bỏ số 0 và ký tự khác

      // Đếm số phím khác nhau (1–9)
      const uniqueCount = new Set(digitsNonZero).size;

      if (uniqueCount <= 3) {
        return { sim: item, status: '2' };
      } else {
        return { sim: item, status: '' };
      }
    });

    // Chỉ giữ lại sim pass
    filteredData = filteredData.filter((item) => item.status === '2');

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);

    setDataExcel(datanew);
  };
  const DinhDang79 = () => {
    // const phongthuy = [
    //   // Thần tài, tài lộc, phát lộc
    //   '39',
    //   '79',
    //   '68',
    //   '86',
    //   '78',
    //   '38',
    //   '83',
    //   '89',
    //   // Lộc trường cửu & biến thể
    //   '69',
    //   '26',
    //   '49',
    //   '13',
    //   '94',
    //   '31',

    //   // Số kép đẹp, tượng trưng trường tồn
    //   '11',
    //   '22',
    //   '33',
    //   '44',
    //   '55',
    //   '66',
    //   '77',
    //   '88',
    //   '99',
    //   '25',
    //   '52',
    // ];
    // const targetPrefixes = ['333', '345', '888', '777', '707', '789', '339499'];
    // const targetSuffixes = [
    //   '333',
    //   '012',
    //   '123',
    //   '234',
    //   '345',
    //   '456',
    //   '567',
    //   '678',
    //   '789',
    //   '8910',
    //   '000',
    //   '111',
    //   '222',
    //   '444',
    //   '555',
    //   '666',
    //   '777',
    //   '888',
    //   '999',
    // ];
    // const dataTrung = [
    //   // ==== Số tiến ====
    //   '0123',
    //   '1234',
    //   '2345',
    //   '3456',
    //   '4567',
    //   '5678',
    //   '6789',
    //   '78910',

    //   // ==== Số lùi ====
    //   '9876',
    //   '8765',
    //   '7654',
    //   '6543',
    //   '5432',
    //   '4321',
    //   '3210',

    //   // ==== Tam hoa ====
    //   '000',
    //   '111',
    //   '222',
    //   '333',
    //   '444',
    //   '555',
    //   '666',
    //   '777',
    //   '888',
    //   '999',
    //   //=========ĐỌC LẠ
    //   '1102',
    //   '1368',
    //   '2626',
    //   '2628',
    //   '4078',
    //   '5656',
    //   '1314',
    //   '1900',
    //   '1800',
    //   '3579',
    //   '2468',

    //   // ==== Nhịp đặc biệt (gãy 1 bước) ====
    //   '344556',
    //   '455667',
    //   '566778',
    //   '677889',
    //   '788990',
    //   '122334',
    //   '233445',
    // ];
    const phones = [];
    const dataArray = dataLocSo?.split('\n');
    const formatList = ['68', '86', '79'];

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });

    let filteredData = phones.map((item) => {
      const normalized = item.startsWith('0') ? item.slice(1) : item;
      // const digitsNonZero = normalized.replace(/[^1-9]/g, '');

      return { sim: item, status: '' };
    });

    // console.log(filteredData);

    function matchPattern(num, pattern, opts = { distinctPlaceholders: true }) {
      if (num.length !== pattern.length) return false;
      const map = Object.create(null);
      const used = new Set();

      for (let i = 0; i < pattern.length; i++) {
        const p = pattern[i];
        const n = num[i];

        if (p === 'x') {
          // wildcard 1 chữ số
          continue;
        }
        if (/\d/.test(p)) {
          // literal digit phải khớp
          if (p !== n) return false;
          continue;
        }
        // placeholder letter
        if (!(p in map)) {
          if (opts.distinctPlaceholders && used.has(n)) return false;
          map[p] = n;
          used.add(n);
        } else if (map[p] !== n) {
          return false;
        }
      }
      return true;
    }

    // Giữ nguyên cấu trúc cũ: kiểm tra ĐUÔI của sim theo độ dài pattern
    filteredData = filteredData.map((s) => {
      const sim = (s.sim || '').replace(/\D/g, '');
      const matched = formatList.some((p) => matchPattern(sim.slice(-p.length), p));
      return { sim, status: matched ? '3' : s.status, fm: '' };
    });
    // console.log(123, filteredData);
    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    setDataExcel(datanew);
  };
  const DD796839 = () => {
    const phones = [];
    const dataArray = dataLocSo?.split('\n');
    const formatList = [
      '68xx68',
      '69xx69',
      '79xx79',
      '1339',
      '3339',
      '8886',
      '6668',
      '6868xx79',
      '3939xx79',
      '3939x79',
      '6868x79',
      '799939',
      '3939x79',
      '3939xx79',
      '357907',
      '357969',
      '357986',
      '357968',
      'aabaab39',
      'aabaab68',
      'aabaab79',
      'aabaab86',
      'abbabb39',
      'abbabb68',
      'abbabb79',
      'abbabb86',
      'ab38ab39',
      'ab68ab79',
      'ab38ab68',
      'ab39ab79',
      'ab68ab86',
      'ab86ab68',
      'ab78ab79',
      'ab67ab68',
      'ab69ab79',
      '797978',
      '797939',
    ];

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });

    let filteredData = phones.map((item) => {
      const normalized = item.startsWith('0') ? item.slice(1) : item;
      // const digitsNonZero = normalized.replace(/[^1-9]/g, '');

      return { sim: item, status: '' };
    });

    // console.log(filteredData);

    function matchPattern(num, pattern, opts = { distinctPlaceholders: true }) {
      if (num.length !== pattern.length) return false;
      const map = Object.create(null);
      const used = new Set();

      for (let i = 0; i < pattern.length; i++) {
        const p = pattern[i];
        const n = num[i];

        if (p === 'x') {
          // wildcard 1 chữ số
          continue;
        }
        if (/\d/.test(p)) {
          // literal digit phải khớp
          if (p !== n) return false;
          continue;
        }
        // placeholder letter
        if (!(p in map)) {
          if (opts.distinctPlaceholders && used.has(n)) return false;
          map[p] = n;
          used.add(n);
        } else if (map[p] !== n) {
          return false;
        }
      }
      return true;
    }

    // Giữ nguyên cấu trúc cũ: kiểm tra ĐUÔI của sim theo độ dài pattern
    filteredData = filteredData.map((s) => {
      const sim = (s.sim || '').replace(/\D/g, '');
      const matched = formatList.some((p) => matchPattern(sim.slice(-p.length), p));
      return { sim, status: matched ? '3' : s.status, fm: '' };
    });
    // console.log(123, filteredData);
    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    setDataExcel(datanew);
  };

  const SANH = () => {
    const phones = [];
    const dataArray = dataLocSo?.split('\n');
    const formatList = ['012', '123', '234', '345', '456', '567', '678', '789', '210'];

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });

    let filteredData = phones.map((item) => {
      const normalized = item.startsWith('0') ? item.slice(1) : item;
      // const digitsNonZero = normalized.replace(/[^1-9]/g, '');

      return { sim: item, status: '' };
    });

    // console.log(filteredData);

    function matchPattern(num, pattern, opts = { distinctPlaceholders: true }) {
      if (num.length !== pattern.length) return false;
      const map = Object.create(null);
      const used = new Set();

      for (let i = 0; i < pattern.length; i++) {
        const p = pattern[i];
        const n = num[i];

        if (p === 'x') {
          // wildcard 1 chữ số
          continue;
        }
        if (/\d/.test(p)) {
          // literal digit phải khớp
          if (p !== n) return false;
          continue;
        }
        // placeholder letter
        if (!(p in map)) {
          if (opts.distinctPlaceholders && used.has(n)) return false;
          map[p] = n;
          used.add(n);
        } else if (map[p] !== n) {
          return false;
        }
      }
      return true;
    }

    // Giữ nguyên cấu trúc cũ: kiểm tra ĐUÔI của sim theo độ dài pattern
    filteredData = filteredData.map((s) => {
      const sim = (s.sim || '').replace(/\D/g, '');
      const matched = formatList.some((p) => matchPattern(sim.slice(-p.length), p));
      return { sim, status: matched ? '3' : s.status, fm: '' };
    });
    // console.log(123, filteredData);
    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    setDataExcel(datanew);
  };
  const SanhGiua = () => {
    const phones = [];
    const dataArray = dataLocSo?.split('\n');
    const formatList = [
      '56789xx',
      '56789x',
      '12345xx',
      '12345x',
      '3456xx',
      '3456x',
      '4567xx',
      '4567x',
      '5678xx',
      '5678x',
      '678910x',
      '678910xx',
      '6789xx',
      '6789x',
    ];

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });

    let filteredData = phones.map((item) => {
      const normalized = item.startsWith('0') ? item.slice(1) : item;
      // const digitsNonZero = normalized.replace(/[^1-9]/g, '');

      return { sim: item, status: '' };
    });

    // console.log(filteredData);

    function matchPattern(num, pattern, opts = { distinctPlaceholders: true }) {
      if (num.length !== pattern.length) return false;
      const map = Object.create(null);
      const used = new Set();

      for (let i = 0; i < pattern.length; i++) {
        const p = pattern[i];
        const n = num[i];

        if (p === 'x') {
          // wildcard 1 chữ số
          continue;
        }
        if (/\d/.test(p)) {
          // literal digit phải khớp
          if (p !== n) return false;
          continue;
        }
        // placeholder letter
        if (!(p in map)) {
          if (opts.distinctPlaceholders && used.has(n)) return false;
          map[p] = n;
          used.add(n);
        } else if (map[p] !== n) {
          return false;
        }
      }
      return true;
    }

    // Giữ nguyên cấu trúc cũ: kiểm tra ĐUÔI của sim theo độ dài pattern
    filteredData = filteredData.map((s) => {
      const sim = (s.sim || '').replace(/\D/g, '');
      const matched = formatList.some((p) => matchPattern(sim.slice(-p.length), p));
      return { sim, status: matched ? '3' : s.status, fm: '' };
    });
    // console.log(123, filteredData);
    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    setDataExcel(datanew);
  };

  const CapGiongNhau = () => {
    const phones = [];
    const dataArray = dataLocSo?.split('\n');

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });

    let filteredData = phones.map((item) => {
      const normalized = item.startsWith('0') ? item.slice(1) : item;
      // const digitsNonZero = normalized.replace(/[^1-9]/g, '');

      return { sim: item, status: '' };
    });
    function hasRepeatedGroups(num, len, minRepeatCount) {
      const n = num.length;
      for (let i = 0; i <= n - len * minRepeatCount; i++) {
        const group = num.slice(i, i + len);
        let count = 1;

        // kiểm tra các cụm kế tiếp có giống nhau không
        let j = i + len;
        while (j + len <= n) {
          const nextGroup = num.slice(j, j + len);
          if (nextGroup === group) {
            count++;
            j += len;
            if (count >= minRepeatCount) return true; // đủ 3 cặp trở lên
          } else {
            break;
          }
        }
      }
      return false;
    }

    filteredData = filteredData.map((item) => {
      const num = String(item.sim).replace(/\D/g, '');

      const repeat3 = hasRepeatedGroups(num, 3, 2); // 2 cặp 3 số liền nhau
      const repeat2x3 = hasRepeatedGroups(num, 2, 3); // 3 cặp 2 số liền nhau trở lên

      if (repeat3 || repeat2x3) {
        return { ...item, status: '2' };
      }
      return item;
    });
    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    setDataExcel(datanew);
  };
  const DinhDang111 = () => {
    const phones = [];
    const dataArray = dataLocSo?.split('\n');
    const formatList = ['000', '111', '222', '333', '444', '555', '666', '777', '888', '999'];

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });

    let filteredData = phones.map((item) => {
      const normalized = item.startsWith('0') ? item.slice(1) : item;
      // const digitsNonZero = normalized.replace(/[^1-9]/g, '');

      return { sim: item, status: '' };
    });

    // console.log(filteredData);

    function matchPattern(num, pattern, opts = { distinctPlaceholders: true }) {
      if (num.length !== pattern.length) return false;
      const map = Object.create(null);
      const used = new Set();

      for (let i = 0; i < pattern.length; i++) {
        const p = pattern[i];
        const n = num[i];

        if (p === 'x') {
          // wildcard 1 chữ số
          continue;
        }
        if (/\d/.test(p)) {
          // literal digit phải khớp
          if (p !== n) return false;
          continue;
        }
        // placeholder letter
        if (!(p in map)) {
          if (opts.distinctPlaceholders && used.has(n)) return false;
          map[p] = n;
          used.add(n);
        } else if (map[p] !== n) {
          return false;
        }
      }
      return true;
    }

    // Giữ nguyên cấu trúc cũ: kiểm tra ĐUÔI của sim theo độ dài pattern
    filteredData = filteredData.map((s) => {
      const sim = (s.sim || '').replace(/\D/g, '');
      const matched = formatList.some((p) => matchPattern(sim.slice(-p.length), p));
      return { sim, status: matched ? '3' : s.status, fm: '' };
    });
    // console.log(123, filteredData);
    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    setDataExcel(datanew);
  };

  const DinhDangG_S = () => {
    const phones = [];
    const dataArray = dataLocSo?.split('\n');
    const formatList = ['678axa', '789axa', '567axa', '456axa', '345axa', '234axa', '123axa'];

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });

    let filteredData = phones.map((item) => {
      const normalized = item.startsWith('0') ? item.slice(1) : item;
      // const digitsNonZero = normalized.replace(/[^1-9]/g, '');

      return { sim: item, status: '' };
    });

    function matchPattern(num, pattern, opts = { distinctPlaceholders: true }) {
      if (num.length !== pattern.length) return false;
      const map = Object.create(null);
      const used = new Set();

      for (let i = 0; i < pattern.length; i++) {
        const p = pattern[i];
        const n = num[i];

        if (p === 'x') {
          // wildcard 1 chữ số
          continue;
        }
        if (/\d/.test(p)) {
          // literal digit phải khớp
          if (p !== n) return false;
          continue;
        }
        // placeholder letter
        if (!(p in map)) {
          if (opts.distinctPlaceholders && used.has(n)) return false;
          map[p] = n;
          used.add(n);
        } else if (map[p] !== n) {
          return false;
        }
      }
      return true;
    }

    // Giữ nguyên cấu trúc cũ: kiểm tra ĐUÔI của sim theo độ dài pattern
    filteredData = filteredData.map((s) => {
      const sim = (s.sim || '').replace(/\D/g, '');
      const matched = formatList.some((p) => matchPattern(sim.slice(-p.length), p));
      return { sim, status: matched ? '3' : s.status, fm: '' };
    });
    // console.log(123, filteredData);
    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    setDataExcel(datanew);
  };
  const DinhDangG_S1 = () => {
    const phones = [];
    const dataArray = dataLocSo?.split('\n');
    const formatList = [
      'axa123',
      'axa234',
      'axa345',
      'axa456',
      'axa567',
      'axa678',
      'axa789',
      'axa8910',
      'axa1233',
      'axa2344',
      'axa3455',
      'axa4566',
      'axa5677',
      'axa6788',
      'axa7899',
      'aaa123',
      'aaa234',
      'aaa345',
      'aaa456',
      'aaa567',
      'aaa678',
      'aaa789',
      'aaa8910',
      'aaa1233',
      'aaa2344',
      'aaa3455',
      'aaa4566',
      'aaa5677',
      'aaa6788',
      'aaa7899',
    ];

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });

    let filteredData = phones.map((item) => {
      const normalized = item.startsWith('0') ? item.slice(1) : item;
      // const digitsNonZero = normalized.replace(/[^1-9]/g, '');

      return { sim: item, status: '' };
    });

    // console.log(filteredData);

    function matchPattern(num, pattern, opts = { distinctPlaceholders: true }) {
      if (num.length !== pattern.length) return false;
      const map = Object.create(null);
      const used = new Set();

      for (let i = 0; i < pattern.length; i++) {
        const p = pattern[i];
        const n = num[i];

        if (p === 'x') {
          // wildcard 1 chữ số
          continue;
        }
        if (/\d/.test(p)) {
          // literal digit phải khớp
          if (p !== n) return false;
          continue;
        }
        // placeholder letter
        if (!(p in map)) {
          if (opts.distinctPlaceholders && used.has(n)) return false;
          map[p] = n;
          used.add(n);
        } else if (map[p] !== n) {
          return false;
        }
      }
      return true;
    }

    // Giữ nguyên cấu trúc cũ: kiểm tra ĐUÔI của sim theo độ dài pattern
    filteredData = filteredData.map((s) => {
      const sim = (s.sim || '').replace(/\D/g, '');
      const matched = formatList.some((p) => matchPattern(sim.slice(-p.length), p));
      return { sim, status: matched ? '6' : s.status, fm: '' };
    });
    // console.log(123, filteredData);
    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    setDataExcel(datanew);
  };

  const TaxiTien = () => {
    const phones = [];
    const dataArray = dataLocSo?.split('\n');

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });

    let filteredData = phones.map((item) => {
      const normalized = item.startsWith('0') ? item.slice(1) : item;
      // const digitsNonZero = normalized.replace(/[^1-9]/g, '');

      return { sim: item, status: '' };
    });

    // console.log(filteredData);

    filteredData = filteredData.map((str) => {
      const sim = str.sim.replace(/\D/g, ''); // bỏ dấu chấm, chỉ lấy số
      const last6 = sim.slice(-6); // lấy 6 số cuối

      // --- Cách 1: chia 3-3 (nút 1,10,100) ---
      const first3 = parseInt(last6.slice(0, 3));
      const last3 = parseInt(last6.slice(3));
      const match6 = last3 === first3 + 1 || last3 === first3 + 10 || last3 === first3 + 100;

      // --- Cách 2: chia thành 3 cặp 2 số ---
      const a = parseInt(last6.slice(0, 2));
      const b = parseInt(last6.slice(2, 4));
      const c = parseInt(last6.slice(4, 6));
      const match2 = (b === a + 1 && c === b + 1) || (b === a + 10 && c === b + 10);

      // Tổng hợp điều kiện
      const duoitien = match6 || match2;

      return duoitien ? { sim: str.sim, status: '2' } : { sim: str.sim, status: str.status };
    });
    // console.log(123, filteredData);
    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    setDataExcel(datanew);
  };

  const TaxiTienAo = () => {
    const phones = [];
    const dataArray = dataLocSo?.split('\n');

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });

    let filteredData = phones.map((item) => ({ sim: item, status: '' }));

    filteredData = filteredData.map((str) => {
      const sim = str.sim.replace(/\D/g, ''); // chỉ lấy số
      const last7 = sim.slice(-7); // lấy 7 số cuối
      const last6 = last7.slice(0, 6); // 6 số đầu
      const lastDigit = last7[6]; // số cuối
      const prevDigit = last7[5]; // số kế trước

      // --- Cách 1: chia 3-3 (nút 1,10,100) ---
      const first3 = parseInt(last6.slice(0, 3));
      const last3 = parseInt(last6.slice(3));
      const match6 = last3 === first3 + 1 || last3 === first3 + 10 || last3 === first3 + 100;

      // --- Cách 2: chia thành 3 cặp 2 số ---
      const a = parseInt(last6.slice(0, 2));
      const b = parseInt(last6.slice(2, 4));
      const c = parseInt(last6.slice(4, 6));
      const match2 = (b === a + 1 && c === b + 1) || (b === a + 10 && c === b + 10);

      // Điều kiện tiến (6 số đầu hợp lệ) + số cuối khớp với số trước
      const duoitienao = (match6 || match2) && lastDigit === prevDigit;

      return duoitienao ? { sim: str.sim, status: '5' } : str;
    });

    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    setDataExcel(datanew);
  };

  const DinhDangTaxi = () => {
    const phones = [];
    const dataArray = dataLocSo?.split('\n');
    const formatList = [
      'abcabc',
      'abaaba',
      'aabaab',
      'abbabb',
      'abcaabca',
      'abccabcc',
      'abbcabbc',
      'aabbaabb',
      'abbbabbb',
      'aaabaaab',
      'aabcaabc',
      'abacabac',
      'abcdabcd',
      'ababab',
    ];

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });

    let filteredData = phones.map((item) => {
      const normalized = item.startsWith('0') ? item.slice(1) : item;
      // const digitsNonZero = normalized.replace(/[^1-9]/g, '');

      return { sim: item, status: '' };
    });

    // console.log(filteredData);

    function matchPattern(num, pattern, opts = { distinctPlaceholders: true }) {
      if (num.length !== pattern.length) return false;
      const map = Object.create(null);
      const used = new Set();

      for (let i = 0; i < pattern.length; i++) {
        const p = pattern[i];
        const n = num[i];

        if (p === 'x') {
          // wildcard 1 chữ số
          continue;
        }
        if (/\d/.test(p)) {
          // literal digit phải khớp
          if (p !== n) return false;
          continue;
        }
        // placeholder letter
        if (!(p in map)) {
          if (opts.distinctPlaceholders && used.has(n)) return false;
          map[p] = n;
          used.add(n);
        } else if (map[p] !== n) {
          return false;
        }
      }
      return true;
    }

    // Giữ nguyên cấu trúc cũ: kiểm tra ĐUÔI của sim theo độ dài pattern
    filteredData = filteredData.map((s) => {
      const sim = (s.sim || '').replace(/\D/g, '');
      const matched = formatList.some((p) => matchPattern(sim.slice(-p.length), p));
      return { sim, status: matched ? '3' : s.status, fm: '' };
    });
    // console.log(123, filteredData);
    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    setDataExcel(datanew);
  };

  const GANH = () => {
    const phones = [];
    const dataArray = dataLocSo?.split('\n');
    const formatList = ['axaaxa', 'aaxxaa'];

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });
    let filteredData = phones.map((item) => {
      const normalized = item.startsWith('0') ? item.slice(1) : item;
      // const digitsNonZero = normalized.replace(/[^1-9]/g, '');

      return { sim: item, status: '' };
    });

    // console.log(filteredData);

    function matchPattern(num, pattern, opts = { distinctPlaceholders: true }) {
      if (num.length !== pattern.length) return false;
      const map = Object.create(null);
      const used = new Set();

      for (let i = 0; i < pattern.length; i++) {
        const p = pattern[i];
        const n = num[i];

        if (p === 'x') {
          // wildcard 1 chữ số
          continue;
        }
        if (/\d/.test(p)) {
          // literal digit phải khớp
          if (p !== n) return false;
          continue;
        }
        // placeholder letter
        if (!(p in map)) {
          if (opts.distinctPlaceholders && used.has(n)) return false;
          map[p] = n;
          used.add(n);
        } else if (map[p] !== n) {
          return false;
        }
      }
      return true;
    }

    // Giữ nguyên cấu trúc cũ: kiểm tra ĐUÔI của sim theo độ dài pattern
    filteredData = filteredData.map((s) => {
      const sim = (s.sim || '').replace(/\D/g, '');
      const matched = formatList.some((p) => matchPattern(sim.slice(-p.length), p));
      return { sim, status: matched ? '3' : s.status, fm: '' };
    });
    // console.log(123, filteredData);
    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    setDataExcel(datanew);
  };
  const AAABxB = () => {
    const phones = [];
    const dataArray = dataLocSo?.split('\n');
    const formatList = ['aaabxb'];

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });

    let filteredData = phones.map((item) => {
      const normalized = item.startsWith('0') ? item.slice(1) : item;
      // const digitsNonZero = normalized.replace(/[^1-9]/g, '');

      return { sim: item, status: '' };
    });

    // console.log(filteredData);

    function matchPattern(num, pattern, opts = { distinctPlaceholders: true }) {
      if (num.length !== pattern.length) return false;
      const map = Object.create(null);
      const used = new Set();

      for (let i = 0; i < pattern.length; i++) {
        const p = pattern[i];
        const n = num[i];

        if (p === 'x') {
          // wildcard 1 chữ số
          continue;
        }
        if (/\d/.test(p)) {
          // literal digit phải khớp
          if (p !== n) return false;
          continue;
        }
        // placeholder letter
        if (!(p in map)) {
          if (opts.distinctPlaceholders && used.has(n)) return false;
          map[p] = n;
          used.add(n);
        } else if (map[p] !== n) {
          return false;
        }
      }
      return true;
    }

    // Giữ nguyên cấu trúc cũ: kiểm tra ĐUÔI của sim theo độ dài pattern
    filteredData = filteredData.map((s) => {
      const sim = (s.sim || '').replace(/\D/g, '');
      const matched = formatList.some((p) => matchPattern(sim.slice(-p.length), p));
      return { sim, status: matched ? '3' : s.status, fm: '' };
    });
    // console.log(123, filteredData);
    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    setDataExcel(datanew);
  };
  const AbAbAxb = () => {
    const phones = [];
    const dataArray = dataLocSo?.split('\n');
    const formatList = ['ababaxb', 'ababxab'];

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });

    let filteredData = phones.map((item) => {
      const normalized = item.startsWith('0') ? item.slice(1) : item;
      // const digitsNonZero = normalized.replace(/[^1-9]/g, '');

      return { sim: item, status: '' };
    });

    // console.log(filteredData);

    function matchPattern(num, pattern, opts = { distinctPlaceholders: true }) {
      if (num.length !== pattern.length) return false;
      const map = Object.create(null);
      const used = new Set();

      for (let i = 0; i < pattern.length; i++) {
        const p = pattern[i];
        const n = num[i];

        if (p === 'x') {
          // wildcard 1 chữ số
          continue;
        }
        if (/\d/.test(p)) {
          // literal digit phải khớp
          if (p !== n) return false;
          continue;
        }
        // placeholder letter
        if (!(p in map)) {
          if (opts.distinctPlaceholders && used.has(n)) return false;
          map[p] = n;
          used.add(n);
        } else if (map[p] !== n) {
          return false;
        }
      }
      return true;
    }

    // Giữ nguyên cấu trúc cũ: kiểm tra ĐUÔI của sim theo độ dài pattern
    filteredData = filteredData.map((s) => {
      const sim = (s.sim || '').replace(/\D/g, '');
      const matched = formatList.some((p) => matchPattern(sim.slice(-p.length), p));
      return { sim, status: matched ? '3' : s.status, fm: '' };
    });
    // console.log(123, filteredData);
    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    setDataExcel(datanew);
  };
  const AABB = () => {
    const phones = [];
    const dataArray = dataLocSo?.split('\n');
    const formatList = ['aabaac', 'abba', 'aabb', 'aabccb', 'abab', 'abacad'];

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });

    let filteredData = phones.map((item) => {
      const normalized = item.startsWith('0') ? item.slice(1) : item;
      // const digitsNonZero = normalized.replace(/[^1-9]/g, '');

      return { sim: item, status: '' };
    });

    // console.log(filteredData);

    function matchPattern(num, pattern, opts = { distinctPlaceholders: true }) {
      if (num.length !== pattern.length) return false;
      const map = Object.create(null);
      const used = new Set();

      for (let i = 0; i < pattern.length; i++) {
        const p = pattern[i];
        const n = num[i];

        if (p === 'x') {
          // wildcard 1 chữ số
          continue;
        }
        if (/\d/.test(p)) {
          // literal digit phải khớp
          if (p !== n) return false;
          continue;
        }
        // placeholder letter
        if (!(p in map)) {
          if (opts.distinctPlaceholders && used.has(n)) return false;
          map[p] = n;
          used.add(n);
        } else if (map[p] !== n) {
          return false;
        }
      }
      return true;
    }

    // Giữ nguyên cấu trúc cũ: kiểm tra ĐUÔI của sim theo độ dài pattern
    filteredData = filteredData.map((s) => {
      const sim = (s.sim || '').replace(/\D/g, '');
      const matched = formatList.some((p) => matchPattern(sim.slice(-p.length), p));
      return { sim, status: matched ? '3' : s.status, fm: '' };
    });
    // console.log(123, filteredData);
    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    setDataExcel(datanew);
  };
  const ABBCBB = () => {
    const phones = [];
    const dataArray = dataLocSo?.split('\n');
    const formatList = ['abbcbb'];

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });

    let filteredData = phones.map((item) => {
      const normalized = item.startsWith('0') ? item.slice(1) : item;
      // const digitsNonZero = normalized.replace(/[^1-9]/g, '');

      return { sim: item, status: '' };
    });

    // console.log(filteredData);

    function matchPattern(num, pattern, opts = { distinctPlaceholders: true }) {
      if (num.length !== pattern.length) return false;
      const map = Object.create(null);
      const used = new Set();

      for (let i = 0; i < pattern.length; i++) {
        const p = pattern[i];
        const n = num[i];

        if (p === 'x') {
          // wildcard 1 chữ số
          continue;
        }
        if (/\d/.test(p)) {
          // literal digit phải khớp
          if (p !== n) return false;
          continue;
        }
        // placeholder letter
        if (!(p in map)) {
          if (opts.distinctPlaceholders && used.has(n)) return false;
          map[p] = n;
          used.add(n);
        } else if (map[p] !== n) {
          return false;
        }
      }
      return true;
    }

    // Giữ nguyên cấu trúc cũ: kiểm tra ĐUÔI của sim theo độ dài pattern
    filteredData = filteredData.map((s) => {
      const sim = (s.sim || '').replace(/\D/g, '');
      const matched = formatList.some((p) => matchPattern(sim.slice(-p.length), p));
      return { sim, status: matched ? '2' : s.status, fm: '' };
    });
    // console.log(123, filteredData);
    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    setDataExcel(datanew);
  };
  const PhongThuyDocLa = () => {
    const phones = [];
    const dataArray = dataLocSo?.split('\n');
    const formatList = [
      'a79b79',
      'a79a78',
      'a39a79',
      'a38a78',
      'a78b78',
      'a39a38',
      '784953',
      '049053',
      'a68b68',
      '4078',
    ];

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });

    let filteredData = phones.map((item) => {
      const normalized = item.startsWith('0') ? item.slice(1) : item;
      // const digitsNonZero = normalized.replace(/[^1-9]/g, '');

      return { sim: item, status: '' };
    });

    // console.log(filteredData);

    function matchPattern(num, pattern, opts = { distinctPlaceholders: true }) {
      if (num.length !== pattern.length) return false;
      const map = Object.create(null);
      const used = new Set();

      for (let i = 0; i < pattern.length; i++) {
        const p = pattern[i];
        const n = num[i];

        if (p === 'x') {
          // wildcard 1 chữ số
          continue;
        }
        if (/\d/.test(p)) {
          // literal digit phải khớp
          if (p !== n) return false;
          continue;
        }
        // placeholder letter
        if (!(p in map)) {
          if (opts.distinctPlaceholders && used.has(n)) return false;
          map[p] = n;
          used.add(n);
        } else if (map[p] !== n) {
          return false;
        }
      }
      return true;
    }

    // Giữ nguyên cấu trúc cũ: kiểm tra ĐUÔI của sim theo độ dài pattern
    filteredData = filteredData.map((s) => {
      const sim = (s.sim || '').replace(/\D/g, '');
      const matched = formatList.some((p) => matchPattern(sim.slice(-p.length), p));
      return { sim, status: matched ? '2' : s.status, fm: '' };
    });
    // console.log(123, filteredData);
    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    setDataExcel(datanew);
  };
  const SANH2 = () => {
    const phones = [];
    const dataArray = dataLocSo?.split('\n');
    const formatList = [
      // 012
      '012012',
      '012123',
      '012234',
      '012345',
      '012456',
      '012567',
      '012678',
      '012789',
      '0128910',

      // 123
      '123012',
      '123123',
      '123234',
      '123345',
      '123456',
      '123567',
      '123678',
      '123789',
      '1238910',

      // 234
      '234012',
      '234123',
      '234234',
      '234345',
      '234456',
      '234567',
      '234678',
      '234789',
      '2348910',

      // 345
      '345012',
      '345123',
      '345234',
      '345345',
      '345456',
      '345567',
      '345678',
      '345789',
      '3458910',

      // 456
      '456012',
      '456123',
      '456234',
      '456345',
      '456456',
      '456567',
      '456678',
      '456789',
      '4568910',

      // 567
      '567012',
      '567123',
      '567234',
      '567345',
      '567456',
      '567567',
      '567678',
      '567789',
      '5678910',

      // 678
      '678012',
      '678123',
      '678234',
      '678345',
      '678456',
      '678567',
      '678678',
      '678789',
      '6788910',

      // 789
      '789012',
      '789123',
      '789234',
      '789345',
      '789456',
      '789567',
      '789678',
      '789789',
      '7898910',

      // 8910
      '8910012',
      '8910123',
      '8910234',
      '8910345',
      '8910456',
      '8910567',
      '8910678',
      '8910789',
      '89108910',
    ];

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });

    let filteredData = phones.map((item) => {
      const normalized = item.startsWith('0') ? item.slice(1) : item;
      // const digitsNonZero = normalized.replace(/[^1-9]/g, '');

      return { sim: item, status: '' };
    });

    // console.log(filteredData);

    function matchPattern(num, pattern, opts = { distinctPlaceholders: true }) {
      if (num.length !== pattern.length) return false;
      const map = Object.create(null);
      const used = new Set();

      for (let i = 0; i < pattern.length; i++) {
        const p = pattern[i];
        const n = num[i];

        if (p === 'x') {
          // wildcard 1 chữ số
          continue;
        }
        if (/\d/.test(p)) {
          // literal digit phải khớp
          if (p !== n) return false;
          continue;
        }
        // placeholder letter
        if (!(p in map)) {
          if (opts.distinctPlaceholders && used.has(n)) return false;
          map[p] = n;
          used.add(n);
        } else if (map[p] !== n) {
          return false;
        }
      }
      return true;
    }

    // Giữ nguyên cấu trúc cũ: kiểm tra ĐUÔI của sim theo độ dài pattern
    filteredData = filteredData.map((s) => {
      const sim = (s.sim || '').replace(/\D/g, '');
      const matched = formatList.some((p) => matchPattern(sim.slice(-p.length), p));
      return { sim, status: matched ? '3' : s.status, fm: '' };
    });
    // console.log(123, filteredData);
    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    setDataExcel(datanew);
  };
  const GANH_TIEN = () => {
    const phones = [];
    const dataArray = dataLocSo?.split('\n');
    const formatList = [
      // a = 1
      '101202',
      '111212',
      '121222',
      '131232',
      '141242',
      '151252',
      '161262',
      '171272',
      '181282',
      '191292',
      '101303',
      '111313',
      '121323',
      '131333',
      '141343',
      '151353',
      '161363',
      '171373',
      '181383',
      '191393',
      '101404',
      '111414',
      '121424',
      '131434',
      '141444',
      '151454',
      '161464',
      '171474',
      '181484',
      '191494',
      '101505',
      '111515',
      '121525',
      '131535',
      '141545',
      '151555',
      '161565',
      '171575',
      '181585',
      '191595',
      '101606',
      '111616',
      '121626',
      '131636',
      '141646',
      '151656',
      '161666',
      '171676',
      '181686',
      '191696',
      '101707',
      '111717',
      '121727',
      '131737',
      '141747',
      '151757',
      '161767',
      '171777',
      '181787',
      '191797',
      '101808',
      '111818',
      '121828',
      '131838',
      '141848',
      '151858',
      '161868',
      '171878',
      '181888',
      '191898',
      '101909',
      '111919',
      '121929',
      '131939',
      '141949',
      '151959',
      '161969',
      '171979',
      '181989',
      '191999',

      // a = 2
      '202303',
      '212313',
      '222323',
      '232333',
      '242343',
      '252353',
      '262363',
      '272373',
      '282383',
      '292393',
      '202404',
      '212414',
      '222424',
      '232434',
      '242444',
      '252454',
      '262464',
      '272474',
      '282484',
      '292494',
      '202505',
      '212515',
      '222525',
      '232535',
      '242545',
      '252555',
      '262565',
      '272575',
      '282585',
      '292595',
      '202606',
      '212616',
      '222626',
      '232636',
      '242646',
      '252656',
      '262666',
      '272676',
      '282686',
      '292696',
      '202707',
      '212717',
      '222727',
      '232737',
      '242747',
      '252757',
      '262767',
      '272777',
      '282787',
      '292797',
      '202808',
      '212818',
      '222828',
      '232838',
      '242848',
      '252858',
      '262868',
      '272878',
      '282888',
      '292898',
      '202909',
      '212919',
      '222929',
      '232939',
      '242949',
      '252959',
      '262969',
      '272979',
      '282989',
      '292999',

      // a = 3
      '303404',
      '313414',
      '323424',
      '333434',
      '343444',
      '353454',
      '363464',
      '373474',
      '383484',
      '393494',
      '303505',
      '313515',
      '323525',
      '333535',
      '343545',
      '353555',
      '363565',
      '373575',
      '383585',
      '393595',
      '303606',
      '313616',
      '323626',
      '333636',
      '343646',
      '353656',
      '363666',
      '373676',
      '383686',
      '393696',
      '303707',
      '313717',
      '323727',
      '333737',
      '343747',
      '353757',
      '363767',
      '373777',
      '383787',
      '393797',
      '303808',
      '313818',
      '323828',
      '333838',
      '343848',
      '353858',
      '363868',
      '373878',
      '383888',
      '393898',
      '303909',
      '313919',
      '323929',
      '333939',
      '343949',
      '353959',
      '363969',
      '373979',
      '383989',
      '393999',

      // a = 4
      '404505',
      '414515',
      '424525',
      '434535',
      '444545',
      '454555',
      '464565',
      '474575',
      '484585',
      '494595',
      '404606',
      '414616',
      '424626',
      '434636',
      '444646',
      '454656',
      '464666',
      '474676',
      '484686',
      '494696',
      '404707',
      '414717',
      '424727',
      '434737',
      '444747',
      '454757',
      '464767',
      '474777',
      '484787',
      '494797',
      '404808',
      '414818',
      '424828',
      '434838',
      '444848',
      '454858',
      '464868',
      '474878',
      '484888',
      '494898',
      '404909',
      '414919',
      '424929',
      '434939',
      '444949',
      '454959',
      '464969',
      '474979',
      '484989',
      '494999',

      // a = 5
      '505606',
      '515616',
      '525626',
      '535636',
      '545646',
      '555656',
      '565666',
      '575676',
      '585686',
      '595696',
      '505707',
      '515717',
      '525727',
      '535737',
      '545747',
      '555757',
      '565767',
      '575777',
      '585787',
      '595797',
      '505808',
      '515818',
      '525828',
      '535838',
      '545848',
      '555858',
      '565868',
      '575878',
      '585888',
      '595898',
      '505909',
      '515919',
      '525929',
      '535939',
      '545949',
      '555959',
      '565969',
      '575979',
      '585989',
      '595999',

      // a = 6
      '606707',
      '616717',
      '626727',
      '636737',
      '646747',
      '656757',
      '666767',
      '676777',
      '686787',
      '696797',
      '606808',
      '616818',
      '626828',
      '636838',
      '646848',
      '656858',
      '666868',
      '676878',
      '686888',
      '696898',
      '606909',
      '616919',
      '626929',
      '636939',
      '646949',
      '656959',
      '666969',
      '676979',
      '686989',
      '696999',

      // a = 7
      '707808',
      '717818',
      '727828',
      '737838',
      '747848',
      '757858',
      '767868',
      '777878',
      '787888',
      '797898',
      '707909',
      '717919',
      '727929',
      '737939',
      '747949',
      '757959',
      '767969',
      '777979',
      '787989',
      '797999',

      // a = 8
      '808909',
      '818919',
      '828929',
      '838939',
      '848949',
      '858959',
      '868969',
      '878979',
      '888989',
      '898999',
    ];

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });

    let filteredData = phones.map((item) => {
      const normalized = item.startsWith('0') ? item.slice(1) : item;
      // const digitsNonZero = normalized.replace(/[^1-9]/g, '');

      return { sim: item, status: '' };
    });

    // console.log(filteredData);

    function matchPattern(num, pattern, opts = { distinctPlaceholders: true }) {
      if (num.length !== pattern.length) return false;
      const map = Object.create(null);
      const used = new Set();

      for (let i = 0; i < pattern.length; i++) {
        const p = pattern[i];
        const n = num[i];

        if (p === 'x') {
          // wildcard 1 chữ số
          continue;
        }
        if (/\d/.test(p)) {
          // literal digit phải khớp
          if (p !== n) return false;
          continue;
        }
        // placeholder letter
        if (!(p in map)) {
          if (opts.distinctPlaceholders && used.has(n)) return false;
          map[p] = n;
          used.add(n);
        } else if (map[p] !== n) {
          return false;
        }
      }
      return true;
    }

    // Giữ nguyên cấu trúc cũ: kiểm tra ĐUÔI của sim theo độ dài pattern
    filteredData = filteredData.map((s) => {
      const sim = (s.sim || '').replace(/\D/g, '');
      const matched = formatList.some((p) => matchPattern(sim.slice(-p.length), p));
      return { sim, status: matched ? '3' : s.status, fm: '' };
    });
    // console.log(123, filteredData);
    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    setDataExcel(datanew);
  };

  const All = () => {
    const phones = [];
    const dataArray = dataLocSo?.split('\n');
    const formatList = [
      'abbcbb',
      'abbcbb',
      'abba',
      'aabb',
      'aabccb',
      'abab',
      'abacad',
      '357907',
      '357969',
      '357986',
      '357968',
      'aabaab39',
      'aabaab68',
      'aabaab79',
      'aabaab86',
      'abbabb39',
      'abbabb68',
      'abbabb79',
      'abbabb86',
      'ab38ab39',
      'ab68ab79',
      'ab38ab68',
      'ab39ab79',
      'ab68ab86',
      'ab86ab68',
      'ab78ab79',
      'ab67ab68',
      'ab69ab79',
      'axaaxa',
      'aaabxb',
      'ababaxb',
      'aaxxaa',
      'abcabc',
      'abaaba',
      'aabaab',
      'abbabb',
      'abcaabca',
      'abccabcc',
      'abbcabbc',
      'aabbaabb',
      'abbbabbb',
      'aaabaaab',
      'aabcaabc',
      'abacabac',
      'abcdabcd',
      'ababab',
      '678axa',
      '789axa',
      '567axa',
      '456axa',
      '345axa',
      '234axa',
      '123axa',
      'axa123',
      'axa234',
      'axa345',
      'axa456',
      'axa567',
      'axa678',
      'axa789',
      'axa8910',
      'axa1233',
      'axa2344',
      'axa3455',
      'axa4566',
      'axa5677',
      'axa6788',
      'axa7899',
      'aaa123',
      'aaa234',
      'aaa345',
      'aaa456',
      'aaa567',
      'aaa678',
      'aaa789',
      'aaa8910',
      'aaa1233',
      'aaa2344',
      'aaa3455',
      'aaa4566',
      'aaa5677',
      'aaa6788',
      'aaa7899',
      '000',
      '111',
      '222',
      '333',
      '444',
      '555',
      '666',
      '777',
      '888',
      '999',
      '56789xx',
      '56789x',
      '2345xx',
      '2345x',
      '3456xx',
      '3456x',
      '4567xx',
      '4567x',
      '5678xx',
      '5678x',
      '678910x',
      '678910xx',
      '6789xx',
      '6789x',
      '123',
      '234',
      '345',
      '456',
      '567',
      '678',
      '789',
      '210',
      'aaaaax',
      'aaaaaxx',
      'aaaaaxxx',
      'xaaxaa',
      'aaxaax',
      'axaaxa',
      'axabab',
      'ababxab',
      '68',
      '86',
      '79',
      '68xx68',
      '69xx69',
      '79xx79',
      '1339',
      '3339',
      '8886',
      '6668',
      '6868xx79',
      '3939xx79',
      '3939x79',
      '6868x79',
      '799939',
      '3939x79',
      '3939xx79',
      // 012
      '012012',
      '012123',
      '012234',
      '012345',
      '012456',
      '012567',
      '012678',
      '012789',
      '0128910',

      // 123
      '123012',
      '123123',
      '123234',
      '123345',
      '123456',
      '123567',
      '123678',
      '123789',
      '1238910',

      // 234
      '234012',
      '234123',
      '234234',
      '234345',
      '234456',
      '234567',
      '234678',
      '234789',
      '2348910',

      // 345
      '345012',
      '345123',
      '345234',
      '345345',
      '345456',
      '345567',
      '345678',
      '345789',
      '3458910',

      // 456
      '456012',
      '456123',
      '456234',
      '456345',
      '456456',
      '456567',
      '456678',
      '456789',
      '4568910',

      // 567
      '567012',
      '567123',
      '567234',
      '567345',
      '567456',
      '567567',
      '567678',
      '567789',
      '5678910',

      // 678
      '678012',
      '678123',
      '678234',
      '678345',
      '678456',
      '678567',
      '678678',
      '678789',
      '6788910',

      // 789
      '789012',
      '789123',
      '789234',
      '789345',
      '789456',
      '789567',
      '789678',
      '789789',
      '7898910',

      // 8910
      '8910012',
      '8910123',
      '8910234',
      '8910345',
      '8910456',
      '8910567',
      '8910678',
      '8910789',
      '89108910',

      // a = 1
      '101202',
      '111212',
      '121222',
      '131232',
      '141242',
      '151252',
      '161262',
      '171272',
      '181282',
      '191292',
      '101303',
      '111313',
      '121323',
      '131333',
      '141343',
      '151353',
      '161363',
      '171373',
      '181383',
      '191393',
      '101404',
      '111414',
      '121424',
      '131434',
      '141444',
      '151454',
      '161464',
      '171474',
      '181484',
      '191494',
      '101505',
      '111515',
      '121525',
      '131535',
      '141545',
      '151555',
      '161565',
      '171575',
      '181585',
      '191595',
      '101606',
      '111616',
      '121626',
      '131636',
      '141646',
      '151656',
      '161666',
      '171676',
      '181686',
      '191696',
      '101707',
      '111717',
      '121727',
      '131737',
      '141747',
      '151757',
      '161767',
      '171777',
      '181787',
      '191797',
      '101808',
      '111818',
      '121828',
      '131838',
      '141848',
      '151858',
      '161868',
      '171878',
      '181888',
      '191898',
      '101909',
      '111919',
      '121929',
      '131939',
      '141949',
      '151959',
      '161969',
      '171979',
      '181989',
      '191999',

      // a = 2
      '202303',
      '212313',
      '222323',
      '232333',
      '242343',
      '252353',
      '262363',
      '272373',
      '282383',
      '292393',
      '202404',
      '212414',
      '222424',
      '232434',
      '242444',
      '252454',
      '262464',
      '272474',
      '282484',
      '292494',
      '202505',
      '212515',
      '222525',
      '232535',
      '242545',
      '252555',
      '262565',
      '272575',
      '282585',
      '292595',
      '202606',
      '212616',
      '222626',
      '232636',
      '242646',
      '252656',
      '262666',
      '272676',
      '282686',
      '292696',
      '202707',
      '212717',
      '222727',
      '232737',
      '242747',
      '252757',
      '262767',
      '272777',
      '282787',
      '292797',
      '202808',
      '212818',
      '222828',
      '232838',
      '242848',
      '252858',
      '262868',
      '272878',
      '282888',
      '292898',
      '202909',
      '212919',
      '222929',
      '232939',
      '242949',
      '252959',
      '262969',
      '272979',
      '282989',
      '292999',

      // a = 3
      '303404',
      '313414',
      '323424',
      '333434',
      '343444',
      '353454',
      '363464',
      '373474',
      '383484',
      '393494',
      '303505',
      '313515',
      '323525',
      '333535',
      '343545',
      '353555',
      '363565',
      '373575',
      '383585',
      '393595',
      '303606',
      '313616',
      '323626',
      '333636',
      '343646',
      '353656',
      '363666',
      '373676',
      '383686',
      '393696',
      '303707',
      '313717',
      '323727',
      '333737',
      '343747',
      '353757',
      '363767',
      '373777',
      '383787',
      '393797',
      '303808',
      '313818',
      '323828',
      '333838',
      '343848',
      '353858',
      '363868',
      '373878',
      '383888',
      '393898',
      '303909',
      '313919',
      '323929',
      '333939',
      '343949',
      '353959',
      '363969',
      '373979',
      '383989',
      '393999',

      // a = 4
      '404505',
      '414515',
      '424525',
      '434535',
      '444545',
      '454555',
      '464565',
      '474575',
      '484585',
      '494595',
      '404606',
      '414616',
      '424626',
      '434636',
      '444646',
      '454656',
      '464666',
      '474676',
      '484686',
      '494696',
      '404707',
      '414717',
      '424727',
      '434737',
      '444747',
      '454757',
      '464767',
      '474777',
      '484787',
      '494797',
      '404808',
      '414818',
      '424828',
      '434838',
      '444848',
      '454858',
      '464868',
      '474878',
      '484888',
      '494898',
      '404909',
      '414919',
      '424929',
      '434939',
      '444949',
      '454959',
      '464969',
      '474979',
      '484989',
      '494999',

      // a = 5
      '505606',
      '515616',
      '525626',
      '535636',
      '545646',
      '555656',
      '565666',
      '575676',
      '585686',
      '595696',
      '505707',
      '515717',
      '525727',
      '535737',
      '545747',
      '555757',
      '565767',
      '575777',
      '585787',
      '595797',
      '505808',
      '515818',
      '525828',
      '535838',
      '545848',
      '555858',
      '565868',
      '575878',
      '585888',
      '595898',
      '505909',
      '515919',
      '525929',
      '535939',
      '545949',
      '555959',
      '565969',
      '575979',
      '585989',
      '595999',

      // a = 6
      '606707',
      '616717',
      '626727',
      '636737',
      '646747',
      '656757',
      '666767',
      '676777',
      '686787',
      '696797',
      '606808',
      '616818',
      '626828',
      '636838',
      '646848',
      '656858',
      '666868',
      '676878',
      '686888',
      '696898',
      '606909',
      '616919',
      '626929',
      '636939',
      '646949',
      '656959',
      '666969',
      '676979',
      '686989',
      '696999',

      // a = 7
      '707808',
      '717818',
      '727828',
      '737838',
      '747848',
      '757858',
      '767868',
      '777878',
      '787888',
      '797898',
      '707909',
      '717919',
      '727929',
      '737939',
      '747949',
      '757959',
      '767969',
      '777979',
      '787989',
      '797999',

      // a = 8
      '808909',
      '818919',
      '828929',
      '838939',
      '848949',
      '858959',
      '868969',
      '878979',
      '888989',
      '898999',
    ];

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });

    let filteredData = phones.map((item) => {
      const normalized = item.startsWith('0') ? item.slice(1) : item;
      // const digitsNonZero = normalized.replace(/[^1-9]/g, '');

      return { sim: item, status: '' };
    });

    // console.log(filteredData);
    function isTien(last6) {
      const first3 = parseInt(last6.slice(0, 3));
      const last3 = parseInt(last6.slice(3));
      const match6 = last3 === first3 + 1 || last3 === first3 + 10 || last3 === first3 + 100;

      const a = parseInt(last6.slice(0, 2));
      const b = parseInt(last6.slice(2, 4));
      const c = parseInt(last6.slice(4, 6));
      const match2 = (b === a + 1 && c === b + 1) || (b === a + 10 && c === b + 10);

      return match6 || match2;
    }

    filteredData = filteredData.map((str) => {
      const sim = str.sim.replace(/\D/g, '');

      // --- Check tiến 6 số ---
      const last6 = sim.slice(-6);
      if (isTien(last6)) {
        return { sim: str.sim, status: '2' };
      }

      // --- Check tiến ảo 7 số ---
      const last7 = sim.slice(-7);
      if (last7.length === 7) {
        const base6 = last7.slice(0, 6);
        const lastDigit = last7[6];
        const prevDigit = last7[5];
        if (isTien(base6) && lastDigit === prevDigit) {
          return { sim: str.sim, status: '5' };
        }
      }

      return str;
    });
    function matchPattern(num, pattern, opts = { distinctPlaceholders: true }) {
      if (num.length !== pattern.length) return false;
      const map = Object.create(null);
      const used = new Set();

      for (let i = 0; i < pattern.length; i++) {
        const p = pattern[i];
        const n = num[i];

        if (p === 'x') {
          // wildcard 1 chữ số
          continue;
        }
        if (/\d/.test(p)) {
          // literal digit phải khớp
          if (p !== n) return false;
          continue;
        }
        // placeholder letter
        if (!(p in map)) {
          if (opts.distinctPlaceholders && used.has(n)) return false;
          map[p] = n;
          used.add(n);
        } else if (map[p] !== n) {
          return false;
        }
      }
      return true;
    }

    // Giữ nguyên cấu trúc cũ: kiểm tra ĐUÔI của sim theo độ dài pattern
    filteredData = filteredData.map((s) => {
      const sim = (s.sim || '').replace(/\D/g, '');
      const matched = formatList.some((p) => matchPattern(sim.slice(-p.length), p));
      return { sim, status: matched ? '3' : s.status, fm: '' };
    });

    function hasRepeatedGroups(num, len, minRepeatCount) {
      const n = num.length;
      for (let i = 0; i <= n - len * minRepeatCount; i++) {
        const group = num.slice(i, i + len);
        let count = 1;

        // kiểm tra các cụm kế tiếp có giống nhau không
        let j = i + len;
        while (j + len <= n) {
          const nextGroup = num.slice(j, j + len);
          if (nextGroup === group) {
            count++;
            j += len;
            if (count >= minRepeatCount) return true; // đủ 3 cặp trở lên
          } else {
            break;
          }
        }
      }
      return false;
    }

    filteredData = filteredData.map((item) => {
      const num = String(item.sim).replace(/\D/g, '');

      const repeat3 = hasRepeatedGroups(num, 3, 2); // 2 cặp 3 số liền nhau
      const repeat2x3 = hasRepeatedGroups(num, 2, 3); // 3 cặp 2 số liền nhau trở lên

      if (repeat3 || repeat2x3) {
        return { ...item, status: '2' };
      }
      return item;
    });
    // console.log(123, filteredData);
    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    setDataExcel(datanew);
  };

  const SearchSim = (dangsim) => {
    const phones = [];
    const dataArray = dataLocSo?.split('\n');
    const formatList = dangsim?.split(',');

    dataArray.forEach((item) => {
      // 1) Tách từ theo khoảng trắng
      const parts = item.trim().split(/\s+/);

      // 2) Kiểm tra: nếu phần đầu tiên là số thứ tự (1–3 chữ số)
      const isIndexNumber = /^\d{1,3}$/.test(parts[0]);

      // 3) Regex tìm cụm số (có thể bị cách)
      const matches = item.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        matches.forEach((match) => {
          let digitsOnly = match.replace(/[^\d]/g, '');

          // ⚠️ Nếu là dòng có số thứ tự, KHÔNG ghép match đầu tiên
          if (isIndexNumber) {
            // số thứ tự + số liền ngay sau → phải bỏ cặp đầu tiên
            if (match.startsWith(parts[0])) return;
          }

          // 4) Ghép sát lại nếu bị tách
          // Điều kiện: độ dài thô sau khi loại ký tự phải trong khoảng hợp lý
          if (digitsOnly.length >= 9 && digitsOnly.length <= 10) {
            // giữ nguyên logic
          } else {
            return; // bỏ những chuỗi vô lý
          }

          // 5) Chuẩn hóa về đúng 10 số
          if (digitsOnly.length === 9) {
            phones.push('0' + digitsOnly);
          } else if (digitsOnly.length === 10) {
            phones.push(digitsOnly);
          }
        });
      }
    });
    let filteredData = phones.map((item) => {
      const normalized = item.startsWith('0') ? item.slice(1) : item;
      // const digitsNonZero = normalized.replace(/[^1-9]/g, '');

      return { sim: item, status: '' };
    });

    // console.log(filteredData);

    function matchPattern(num, pattern, opts = { distinctPlaceholders: true }) {
      if (num.length !== pattern.length) return false;
      const map = Object.create(null);
      const used = new Set();

      for (let i = 0; i < pattern.length; i++) {
        const p = pattern[i];
        const n = num[i];

        if (p === 'x') {
          // wildcard 1 chữ số
          continue;
        }
        if (/\d/.test(p)) {
          // literal digit phải khớp
          if (p !== n) return false;
          continue;
        }
        // placeholder letter
        if (!(p in map)) {
          if (opts.distinctPlaceholders && used.has(n)) return false;
          map[p] = n;
          used.add(n);
        } else if (map[p] !== n) {
          return false;
        }
      }
      return true;
    }

    // Giữ nguyên cấu trúc cũ: kiểm tra ĐUÔI của sim theo độ dài pattern
    filteredData = filteredData.map((s) => {
      const sim = (s.sim || '').replace(/\D/g, '');
      const matched = formatList.some((p) => matchPattern(sim.slice(-p.length), p));
      return { sim, status: matched ? '2' : s.status, fm: '' };
    });
    // console.log(123, filteredData);
    filteredData = filteredData.filter(
      (item) =>
        item.status === '2' || item.status === '3' || item.status === '4' || item.status === '5' || item.status === '6',
    );

    // lấy dữ liệu hoàn thiện
    const simList = filteredData.map((item) => item.sim);

    const datanew = dataLocSoOld.reduce((acc, entry) => {
      // Bắt số có thể bị cách 9–13 ký tự
      const matches = entry.match(/(?:\d[., ]?){9,13}/g);

      if (matches) {
        for (let m of matches) {
          const cleaned = normalizePhone(m, entry);

          if (!cleaned) continue; // bỏ nếu không hợp lệ

          // Nếu số đã chuẩn nằm trong simList
          if (simList.includes(cleaned)) {
            const matched = filteredData.find((item) => item.sim === cleaned);

            acc.push({
              sim: entry, // giữ nguyên dữ liệu cũ 100%
              status: matched?.status ?? '0',
            });
          }
        }
      }

      return acc;
    }, []);
    setDataExcel(datanew);
  };

  const handleKeyDownSearch = (e) => {
    if (e.key === 'Enter') {
      if (e.target.value) {
        SearchSim(e.target.value);
      }
      // console.log(e.target.value);
    }
  };
  return (
    <Container sx={{ pb: '90px' }}>
      <Button variant="contained" color="success" component={Link} to="/dashboard">
        Quay lại
      </Button>
      <Grid container sx={{ mb: '70px' }}>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Grid item xs={12} md={8} sx={{ mt: 1 }}>
            <Box sx={{ mt: 1.5 }}>
              <TextField
                ref={inputRef}
                label="TEXT Lọc số"
                size="small"
                variant="outlined"
                value={dataLocSo}
                color="error"
                multiline
                rows={4}
                onChange={(e) => {
                  convertTextToArrayLocSo(e.target.value);
                }}
                fullWidth
                focused
              />
            </Box>
            <span style={{ color: 'red' }}>{message}</span>
            <br />
          </Grid>
          {/* <Grid item xs={12} sx={{ mt: 1 }}>
            
          </Grid> */}
          <Grid container item xs={12} md={8}>
            <Grid item xs={12}>
              <div>{dataExcel.length} sim</div>
            </Grid>
            <Grid item xs={5} ref={divRef}>
              {dataExcel.map((row, i) => (
                <div
                  key={i}
                  style={{
                    color:
                      row.status === '2'
                        ? 'red'
                        : row.status === '3'
                        ? 'blue'
                        : row.status === '4'
                        ? 'green'
                        : row.status === '5'
                        ? 'blueviolet'
                        : row.status === '6'
                        ? 'firebrick'
                        : 'black',
                    fontSize: '15px',
                  }}
                >
                  {row[0] || row.sim} {row.fm ? ' - ' + row.fm : ''}
                </div>
              ))}
            </Grid>

            <Grid item xs={7}>
              <Box sx={{ mb: 1 }}>
                <Box sx={{ mb: '5px' }}>
                  <Button variant="contained" color="success" onClick={handlePaste} size="small" sx={{ mr: '5px' }}>
                    Dán
                  </Button>
                  <Button variant="contained" color="error" onClick={handleCopy} sx={{ mr: '5px' }} size="small">
                    Copy
                  </Button>
                  <Button
                    variant="contained"
                    color="info"
                    // sx={{ ml: 1 }}
                    onClick={() => setIsInputSearch(!isInputSearch)}
                    size="small"
                  >
                    {isInputSearch ? 'Đóng' : 'Tìm'}
                  </Button>
                </Box>
                {isInputSearch && (
                  <TextField
                    label="Tìm sim"
                    size="small"
                    placeholder="đuôi sim, a79b79..."
                    onKeyDown={handleKeyDownSearch}
                  />
                )}
              </Box>
              <Box
                sx={{
                  height: { xs: '400px', md: '500px' },
                  overflowY: 'auto', // cuộn dọc
                  overflowX: 'hidden', // tránh xô ngang
                  display: 'flex',
                  flexWrap: 'wrap', // giữ đúng bố cục cũ
                  border: '1px dashed red',
                  borderRadius: '10px',
                }}
              >
                <Button variant="contained" color="warning" onClick={subLoc6886} sx={{ m: '5px' }} size="small">
                  BCLS 68
                </Button>
                <Button variant="contained" color="success" onClick={subLoc6886_09} sx={{ m: '5px' }} size="small">
                  BCLS 09*68
                </Button>
                <Button variant="contained" color="success" onClick={subLoc6886_095} sx={{ m: '5px' }} size="small">
                  BCLS 09*685
                </Button>
                <Button variant="contained" color="secondary" onClick={PhoneFilterDauSo} sx={{ m: '5px' }} size="small">
                  ĐẦU SỐ
                </Button>

                <Button variant="contained" color="warning" onClick={TaxiTien} sx={{ m: '5px' }} size="small">
                  SIM TIẾN
                </Button>
                <Button variant="contained" color="warning" onClick={TaxiTienAo} sx={{ m: '5px' }} size="small">
                  SIM TIẾN ẢO
                </Button>

                <Button variant="contained" onClick={CapGiongNhau} sx={{ m: '5px' }} size="small">
                  CẶP TRÙNG
                </Button>

                <Button variant="contained" color="success" onClick={PhongThuyDocLa} sx={{ m: '5px' }} size="small">
                  ĐẶC BIỆT
                </Button>

                <Button variant="contained" color="warning" onClick={subLoc6SoYes0986} sx={{ m: '5px' }} size="small">
                  BCLS ÔM
                </Button>
                <Button variant="contained" color="warning" onClick={subLoc6So} sx={{ m: '5px' }} size="small">
                  BCLS 6 SỐ
                </Button>
                <Button variant="contained" color="warning" onClick={subLoc6SoCo5} sx={{ m: '5px' }} size="small">
                  BCLS Có 5
                </Button>
                <Button variant="contained" color="warning" onClick={subLoc4So} sx={{ m: '5px' }} size="small">
                  BCLS 4 SỐ
                </Button>
                <Button variant="contained" onClick={ABBCBB} sx={{ m: 1 }} size="small">
                  ABB.CBB
                </Button>

                {/* <Button variant="contained" onClick={PhoneFilterTien2Phim} sx={{ m: 1 }} size="small">
            LUNG TUNG
          </Button> */}
                <Button variant="contained" color="secondary" onClick={All} sx={{ m: '5px' }} size="small">
                  TỔNG DẠNG
                </Button>
                <Button
                  variant="contained"
                  color="warning"
                  onClick={PhoneFilterTien3Phim}
                  sx={{ m: '5px' }}
                  size="small"
                >
                  ÍT PHÍM
                </Button>
                <Button variant="contained" color="warning" onClick={DinhDang79} sx={{ m: '5px' }} size="small">
                  ĐUÔI 79.86.68
                </Button>
                <Button variant="contained" color="warning" onClick={DD796839} sx={{ m: '5px' }} size="small">
                  ẢO 796839
                </Button>
                <Button variant="contained" color="warning" onClick={SANH} sx={{ m: '5px' }} size="small">
                  SẢNH
                </Button>
                <Button variant="contained" color="warning" onClick={SanhGiua} sx={{ m: '5px' }} size="small">
                  SẢNH GIỮA
                </Button>
                <Button variant="contained" color="warning" onClick={SANH2} sx={{ m: '5px' }} size="small">
                  2 SẢNH
                </Button>

                <Button variant="contained" color="warning" onClick={DinhDangG_S} sx={{ m: '5px' }} size="small">
                  SẢNH + GÁNH
                </Button>
                <Button variant="contained" color="warning" onClick={DinhDangG_S1} sx={{ m: '5px' }} size="small">
                  GÁNH + SẢNH
                </Button>
                <Button variant="contained" color="warning" onClick={DinhDang111} sx={{ m: '5px' }} size="small">
                  TAM HOA
                </Button>
                <Button variant="contained" color="warning" onClick={DinhDangTaxi} sx={{ m: '5px' }} size="small">
                  TAXI
                </Button>
                <Button variant="contained" color="warning" onClick={GANH} sx={{ m: '5px' }} size="small">
                  GÁNH
                </Button>
                <Button variant="contained" color="warning" onClick={AAABxB} sx={{ m: '5px' }} size="small">
                  AAA.BxB
                </Button>
                <Button variant="contained" color="warning" onClick={AbAbAxb} sx={{ m: '5px' }} size="small">
                  AB.AB.xAB
                </Button>
                <Button variant="contained" color="warning" onClick={AABB} sx={{ m: '5px' }} size="small">
                  AB.AB _ AABB
                </Button>

                <Button variant="contained" color="warning" onClick={GANH_TIEN} sx={{ m: '5px' }} size="small">
                  2 GÁNH TIẾN
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default LocSoDep;
